export const LANGUAGES = [
  { code: "EN", label: "English" },
  { code: "ES", label: "Español" },
  { code: "FR", label: "Français" },
  { code: "PT", label: "Português" },
];

export function detectLanguage() {
  const nav = (navigator.language || "en").toLowerCase().slice(0, 2);
  if (nav === "es") return "ES";
  if (nav === "fr") return "FR";
  if (nav === "pt") return "PT";
  return "EN";
}

export const T = {
  EN: {
    tagline: "BUSINESS OBSERVABILITY FRAMEWORK",
    bossLink: "a Boss.Technology",
    pageTitle: "Build a Chass1s.",
    inputInstruction: "ENTER A BUSINESS TYPE or current COMPANY NAME, LOCATION, WEBSITE, OBJECTIVES, CONCEPTS OR ANY COMBINATION — SEPARATED BY COMMAS.",
    deployHint: "⌘ + ENTER TO DEPLOY · OPENS IN NEW TAB",
    startBtn: "START FABRICATING",
    whatIsChs: "WHAT IS CHASS1S?",
    chsDescription: "CHASS1S is the world's first and only Business Observability (BO11Y) Framework — with the power to Fabricate, Tune, and even Drive any new or existing business, from an ice cream shop to an airline. For the first time, technology and business are unified into a single powerful vehicle — where every decision, every change, and every insight cascades with full awareness of the whole. Through Business Observability, powered by Applied AI, CHASS1S turns the complexity of running a business into something observable, measurable, and actionable. The modern Framework for Fast Companies and Real-Time Businesses.",
    chsCreditBoss: { prefix: "CHASS1S is brought to you by ", name: "Boss.Technology", suffix: " — Latin American based Premium Business Observability Builder, Tuner, and Brand." },
    chsCreditFederico: { prefix: "Created by ", name: "Federico Lara", suffix: " — Business Observability thought leader, author of Six Steps to Achieve Business Observability, creator of Metric Monetization, and former executive at New Relic and Dynatrace." },
    selectDepth: "SELECT CHASSIS DEPTH",
    tabs: { intro: "INTRO", introSub: "Business Overview", addis: "ADDIS", addisSub: "Technology Layer", blips: "BLIPS", blipsSub: "Business Layer", kbrs: "KBRs", kbrsSub: "Key Business Results", compliance: "COMPLIANCE", complianceSub: "CORP · REG. · EVR" },
    expandAll: "EXPAND ALL", collapseAll: "COLLAPSE ALL",
    sections: "SECTIONS", items: "ITEMS",
    businessProfile: "BUSINESS PROFILE", whyChassis: "CHASSIS", keyValuePoints: "KEY VALUE POINTS", frameworkApplied: "CHASSIS APPLIED",
    addisDesc: "Maps every technology tool, platform, system, and infrastructure component this business depends on.",
    blipsDesc: "Maps every business function and the observable tools and data sources that connect technology performance to business outcomes.",
    kbrTitle: "Key Business Results", kbrsAcross: "KBRs ACROSS", businessAreas: "BUSINESS AREAS",
    metric: "METRIC", target: "TARGET",
    newChassis: "NEW CHASSIS",
    loadingTitle: "PROCESSING",
    loadingSteps: ["ANALYZING BUSINESS TYPE...", "MAPPING ADDIS TECHNOLOGY LAYER...", "BUILDING BLIPS BUSINESS CHASSIS...", "GENERATING KEY BUSINESS RESULTS...", "FABRICATING CHASSIS..."],
    fabricatingPrefix: "FABRICATING",
    charmingPhrases: [
      "This one's moving fast — brace yourself.",
      "Still here? Good. So are we. This is going well.",
      "Go ahead and stretch a little. We'll be ready when you are.",
      "This is taking a moment. A good moment — like a fine espresso kind of moment.",
      "While you're waiting, go hug a pet... it doesn't have to be your own.",
      "Could be a few minutes — go ahead and order that overly complicated beverage you love.",
      "We're building something custom, specific, yours. Good things take time.",
      "Still going. This is our most thorough work. Make yourself a snack. You've earned it.",
    ],
    errorTitle: "Something went wrong.", tryAgain: "TRY AGAIN",
    errorBpNotSaved: "Beyond Profit was generated but could not be saved. Copy anything you need before reloading.",
    tableHeaders: ["Item", "Type", "Description", "In/Ex", "Environment", "Data"],
    tableHeadersBlips: ["Item", "Source", "Type", "Description", "In/Ex", "Environment", "Data"],
    noItems: "No items generated.",
    tiers: [
      { id: "compact", label: "Compact", description: "Essential overview. Core ADDIS & BLIPS items with focused KBRs. Ideal for quick assessments." },
      { id: "midsize", label: "Mid-Size", description: "Enhanced depth with richer context. More items, fuller descriptions, and expanded real-world factors." },
      { id: "executive", label: "Executive", description: "Comprehensive analysis with detailed context, real-world coverage, and rich KBR targets with industry benchmarks." },
      { id: "luxury", label: "Luxury", description: "Enterprise-grade intelligence. Maximum depth, narrative impact analysis, risk register, quick wins, and full industry context." },
    ],
    examples: [
      "Häagen-Dazs, UK Regent Street, https://www.haagen-dazs.co.uk/, Increase sales by 20% during the winter months.",
      "Motorcycle Shop, Medellín Colombia Laureles, Add Rentals and custom tuning new services, $2,000 USD budget.",
      "Mercado Libre, https://www.mercadolibre.com/",
      "Boutique Hotel, Cartagena Colombia, Expand bookings for international travelers, Launch loyalty program.",
      "Tesla, https://www.tesla.com/, Optimize service center operations, Reduce wait times by 30%.",
      "Independent Pharmacy, Miami Florida, Compete with CVS and Walgreens, Add delivery and telehealth services.",
      "CrossFit Gym, Brooklyn New York, Grow membership base, Launch online training program, $5,000 monthly budget.",
      "Family Law Firm, Mexico City, Attract high-net-worth clients, Build digital presence and referral strategy.",
    ],
    beyondProfit: "BEYOND PROFIT",
    beyondProfitSub: "Optional",
    beyondProfitDesc: "Select any initiatives relevant to this business. Results will appear as a dedicated tab.",
    beyondProfitTab: "Beyond Profit",
    beyondProfitTabSub: "Legal, Social & Regulatory Insights",
    complianceSectionGovernance: "CORPORATE GOVERNANCE",
    complianceSectionRegulatory: "REGULATORY & INDUSTRY COMPLIANCE",
    complianceSectionEVR:        "ESTIMATED VALUE AT RISK",
    complianceImplementation:    "IMPLEMENTATION",
    compliancePerformance:       "PERFORMANCE",
    complianceCompliance:        "COMPLIANCE",
    complianceAnnualRange:       "ANNUAL EXPOSURE RANGE",
    compliancePerIncident:       "PER-INCIDENT COST",
    complianceRefs:              "ADDIS · BLIPS",
    complianceFabNote:           "Suggested — confirm with evidence in Tune",
    bpOptions: { CSR: "CSR", ESG: "ESG", DEI: "DEI", TBL: "TBL", Sustainability: "SUS" },
    bpDefinitions: {
      CSR: "CSR — Corporate Social Responsibility",
      ESG: "ESG — Environmental, Social & Governance",
      DEI: "DEI — Diversity, Equity & Inclusion",
      TBL: "TBL — Triple Bottom Line",
      Sustainability: "SUS — Sustainability",
    },
    useTokens: "USE",
    tokensPer: "1 TOKEN PER",
    insufficientTokens: "INSUFFICIENT TOKENS",
    required: "REQUIRED",
    bpLabels: { legal: "LEGAL", social: "SOCIAL", regulatory: "REGULATORY", news: "NEWS & DEVELOPMENTS", suggestions: "SUGGESTIONS" },
    bp: { analyzing: "ANALYZING", gatheringContext: "GATHERING LEGAL & REGULATORY CONTEXT...", generatingInsights: "GENERATING INSIGHTS & SUGGESTIONS...", errorMsg: "Could not generate Beyond Profit insights." },
    pdfControlled: "CONTROLLED",
    pdfUncontrolled: "UNCONTROLLED",
    sectionInfo: {
      Apps: "Specific software applications the business uses daily — SaaS platforms, mobile/web apps, productivity tools, and industry-specific applications.",
      Data: "Databases, data warehouses, BI tools, and data storage platforms — the technology that stores and processes business data.",
      Dev: "Development tools, version control, CI/CD pipelines, APIs consumed, and deployment tools — the technology stack that builds and maintains software.",
      Infrastructure: "Servers, cloud platforms, networks, IoT devices, CDNs, and hardware — the physical and virtual foundation everything runs on.",
      Systems: "Enterprise-scale platforms that orchestrate operations — ERP, CRM, WMS, MES, and SIEM systems.",
      BizOps: "Day-to-day business operations, administrative processes, financial management, and organizational governance.",
      Logistics: "Supply chain, transportation, delivery networks, distribution, and fulfillment operations.",
      Inventory: "Stock management, warehouse operations, product tracking, and procurement processes.",
      Production: "Manufacturing, service delivery, quality control, and output processes that create the product or service.",
      Sales: "Revenue generation, customer acquisition, pricing strategy, marketing campaigns, and customer relationship management.",
    },
    errorEmailNotConfirmed: "Please confirm your email address before generating. Check your inbox.",
    errorConnectionTimeout: "The connection took more than 60 seconds to establish. Please try again.",
    errorInsufficientBalance: "Insufficient token balance.",
    errorAccountNotFound: "Account not found.",
    errorSaveChassis: "Could not save your Chassis. No tokens were charged.",
    auth: {
      signInTitle:    "Sign In to CHASS1S",
      signUpTitle:    "Create Your Account",
      resetTitle:     "Reset Your Password",
      signInTab:      "SIGN IN",
      signUpTab:      "CREATE ACCOUNT",
      forgotTab:      "RESET PASSWORD",
      emailLabel:     "EMAIL ADDRESS",
      passwordLabel:  "PASSWORD",
      redirecting:    "REDIRECTING...",
      processing:     "PROCESSING...",
      sending:        "SENDING...",
      sendReset:      "SEND RESET EMAIL",
      backToSignIn:   "Back to Sign In",
      forgotLink:     "Forgot password?",
      signUpSuccess:  "Account created! Check your email to confirm.",
      resetSuccess:   "Password reset email sent. Check your inbox.",
      freeTokens:     "New accounts receive 10 FREE TOKENS — no credit card required.",
      orContinueWith: "OR CONTINUE WITH",
    },
    // ── Account Menu ──
    menuSignedInAs: "SIGNED IN AS",
    menuWorkspace: "WORKSPACE",
    menuPersonal: "Personal",
    menuAddWorkspace: "+ Workspace",
    menuChassis: "CHASSIS",
    menuTokenBalance: "TOKEN BALANCE",
    menuBuyMore: "+ Buy More",
    menuLanguage: "LANGUAGE",
    menuSignOut: "SIGN OUT",
    // ── Workspace configuration & deletion ──
    workspaceConfigEyebrow: "WORKSPACE · CONFIGURATION",
    workspaceConfigure: "Configure workspace",
    workspaceAddMember: "ADD MEMBER",
    workspaceDelete: "Delete workspace",
    workspaceDeleteTitle: "⚠ DELETE WORKSPACE",
    workspaceDeleteBody: "You are about to permanently delete {name}. This action cannot be undone.",
    workspaceDeleteImpact: "THIS WILL AFFECT:",
    workspaceDeleteChassis: "{n} chassis will be permanently deleted",
    workspaceDeleteMembers: "{n} members will lose access",
    workspaceDeleteAck: "I understand this workspace and all its chassis will be permanently deleted.",
    workspaceDeleteConfirm: "DELETE PERMANENTLY",
    workspaceDeleteCancel: "CANCEL",
    chassisDeleteNotOwner: "Only the person who created this Chassis can delete it.",
    workspaceInviteNoAccount: "No CHASS1S account found with that email. Ask them to sign up first.",
    workspaceInviteAlreadyMember: "That user is already a member of this workspace.",
    workspaceInviteAdded: "{email} added as {role}.",
    workspaceRoleMember: "Member",
    workspaceRoleCoOwner: "Co-Owner",
    workspaceInviteMailFailed: "Member added, but the notification email could not be sent.",
    // ── Settings & Support ──
    menuSettings: "Settings",
    menuSupport: "Support",
    settingsTitle: "Account Settings",
    settingsSectionProfile: "PROFILE INFO",
    settingsSave: "SAVE CHANGES",
    settingsSaving: "SAVING...",
    settingsSaved: "✓ Saved",
    settingsSectionSecurity: "SECURITY",
    settingsNewEmail: "NEW EMAIL ADDRESS",
    settingsUpdateEmail: "UPDATE EMAIL",
    settingsCurrentPassword: "CURRENT PASSWORD",
    settingsNewPassword: "NEW PASSWORD",
    settingsConfirmPassword: "CONFIRM NEW PASSWORD",
    settingsUpdatePassword: "UPDATE PASSWORD",
    settingsOAuthNoPassword: "Password login is not available for your account. You signed in with a social provider.",
    settingsSectionConnected: "CONNECTED ACCOUNTS",
    settingsSectionDanger: "CLOSE ACCOUNT",
    settingsDangerWarning: "Your account will be scheduled for deletion in 30 days. You can reactivate by signing in before that date.",
    settingsDangerPrompt: "Type DELETE to confirm",
    settingsDeactivateBtn: "DEACTIVATE ACCOUNT",
    settingsDeactivated: "Account deactivated. You will be signed out.",
    settingsDangerShow: "Show options",
    settingsDisplayName: "DISPLAY NAME",
    settingsCountry: "COUNTRY",
    settingsSelectPlaceholder: "— Select —",
    settingsAgeRange: "AGE RANGE",
    settingsRoles: "YOUR ROLE(S)",
    settingsEmailPasswordHint: "Enter your current password to begin.",
    settingsCurrentPwdPh: "Current password",
    settingsShow: "show",
    settingsHide: "hide",
    settingsVerifyPassword: "VERIFY PASSWORD",
    settingsOtpHint: "A code was sent to {email}. Enter it below.",
    settingsOtpPlaceholder: "6-digit code",
    settingsVerifyCode: "VERIFY CODE",
    settingsCancel: "Cancel",
    settingsIdentityVerified: "Identity verified. Enter your new email address.",
    settingsNewEmailPlaceholder: "New email address",
    settingsSendConfirmation: "SEND CONFIRMATION",
    settingsConfirmationSent: "Confirmation sent to {email}. Check your inbox.",
    settingsDone: "DONE",
    settingsLinkingNote: "Linking / unlinking not available in this version.",
    settingsChangePassword: "CHANGE PASSWORD",
    settingsPwdUpdated: "Updated",
    settingsErrIncorrectPwd: "Incorrect password. Please try again.",
    settingsErrNetwork: "Network error. Please try again.",
    settingsErrPwdMatch: "Passwords do not match",
    settingsErrPwdLength: "Minimum 6 characters",
    settingsErrCurrentPwd: "Current password is incorrect",
    settingsErrInvalidCode: "Invalid or expired code.",
    supportTitle: "Contact Support",
    supportCategoryLabel: "ISSUE CATEGORY",
    supportCategories: ["Billing & Tokens", "Technical Issue", "Account Access", "Generation Quality", "Feature Request", "Other"],
    supportCategoryPlaceholder: "— Select category —",
    supportDescriptionLabel: "DESCRIPTION",
    supportDescriptionPlaceholder: "Describe your issue in detail (minimum 20 characters)...",
    supportAttachLabel: "ATTACHMENT (optional)",
    supportChooseFile: "CHOOSE FILE",
    supportFileSizeError: "File must be under 5MB",
    supportFileTypeError: "Only images and PDF files are accepted",
    supportSubmit: "SUBMIT TICKET",
    supportSubmitting: "SUBMITTING...",
    supportSuccessTitle: "Ticket Submitted",
    supportSuccessMsg: "We'll get back to you within 24–48 hours. Your ticket number is:",
    supportAttachFailed: "Your ticket was submitted, but the file could not be attached. Reply to the confirmation email to send it.",
    supportClose: "CLOSE",
    tokenBreadcrumb: "CHASS1S - TOKEN PURCHASE",
    tokenTitle: "Buy Tokens",
    tokenBalance: "Current balance:",
    tokenBalanceSuffix: "tokens",
    tokenDepositLabel: "DEPOSIT AMOUNT (USD)",
    tokenMinMax: "Minimum $25.00 - Maximum $1,000.00",
    tokenBreakdownLabel: "TOKEN BREAKDOWN",
    tokenBaseTokens: "Base tokens ($1 = 1 token)",
    tokenVolumeBonus: "Volume bonus",
    tokenTotal: "TOTAL TOKENS",
    tokenPromoLabel: "PROMO CODE (OPTIONAL)",
    tokenPromoPlaceholder: "Enter code",
    tokenApply: "APPLY",
    tokenPromoError: "Invalid promo code.",
    tokenPromoNetworkErr: "Could not validate promo code.",
    tokenProceedBtn: "PROCEED TO STRIPE",
    tokenCostLabel: "CHASSIS COST REFERENCE",
    tokenFooter: "Payments processed securely by Stripe - Tokens never expire - Non-refundable",
    historyBreadcrumb: "CHASS1S - CHASSIS HISTORY",
    historyTitle: "My Chassis",
    historyCount: "{n} Chassis generated",
    historyLoading: "LOADING...",
    historyEmpty: "NO CHASSIS YET",
    historyEmptyDesc: "Generate your first Chassis and it will appear here.",
    historyUnnamed: "Unnamed Chassis",
    historyOpen: "OPEN",
    workspaceCreateTitle: "Create Workspace",
    workspaceCreateDesc: "Collaborate with your team and share a token pool. You'll be the Owner.",
    workspaceNameLabel: "WORKSPACE NAME",
    workspaceNamePh: "e.g. Acme Corp, Marketing Team...",
    workspaceCreating: "CREATING...",
    workspaceCreateBtn: "CREATE WORKSPACE",
    workspaceCreateFooter: "Co-owners & Members can be invited from workspace settings after creation.",
    workspaceCreateError: "Failed to create workspace",
    modeSelector: {
      fabricate: "Fabricate",
      tune: "Tune",
      drive: "Drive",
      go: "GO",
      comingSoon: "Coming Soon",
    },
    tune: {
      lessonsColumn: "LESSONS",
      payModalTitle: "ENTER TUNE MODE",
      payModalBody: "Entering Tune mode allows you to edit every element of this Chassis. Once paid, toggle freely until you Refabricate.",
      payConfirm: "USE {n} TOKENS & ENTER TUNE",
      balance: "BALANCE",
      modeOn: "TUNE: ON",
      clickToExit: "CLICK TO EXIT",
      activeIndicatorTooltip: "Tune mode is active",
      editHistoryTitle: "EDIT HISTORY",
      loadingHistory: "LOADING HISTORY...",
      noEditHistory: "No edit history for this element.",
      revertButton: "REVERT TO THIS VERSION",
      pctOnRefabricate: "PERCENTAGES RECALCULATED ON REFABRICATE",
      downgradeTitleWarning: "⚠ TIER DOWNGRADE — REDUCED DEPTH",
      downgradeBody: "Downgrading to a smaller tier will reduce the number of ADDIS items, BLIPS items, KBRs, and Compliance detail in your refabricated Chassis. Tune edits you have confirmed will still be respected as ground truth, but the smaller token budget means some areas will be condensed or reduced to fit. You can upgrade again at any time by refabricating at a higher tier.",
      addElement: "ADD ELEMENT",
      teach: "TEACH",
      addElementTitle: "ADD ELEMENT",
      addElementManual: "MANUAL ENTRY",
      addElementAssisted: "ASSISTED",
      addElementConsultant: "CONSULTANT VIEW",
      addElementNameLabel: "ELEMENT NAME",
      addElementTypeLabel: "TYPE",
      addElementDataLabel: "DATA",
      addElementTitleLabel: "TITLE",
      addElementDescLabel: "DESCRIPTION",
      addElementMetricLabel: "METRIC",
      addElementTargetLabel: "TARGET",
      addElementInExLabel: "IN / EX",
      addElementEnvLabel: "ENV",
      addElementSourceLabel: "SOURCE",
      addElementSave: "SAVE ELEMENT",
      addElementAssistedPrompt: "Describe what you want to add and AI will suggest matching elements.",
      addElementGenerate: "GENERATE SUGGESTIONS",
      addElementConsultantPrompt: "Describe the business context and AI will propose elements from a consultant perspective.",
      teachTitle: "TEACH",
      saveContentError: "Could not save this content.",
      addContentInput: "INPUT",
      addContentAttach: "ATTACH",
      addContentCapture: "CAPTURE",
      addContentLink: "LINK",
      addContentConnect: "CONNECT",
      teachTooltip: "Teach CHASS1S about the selected elements",
      lessons: "LESSONS",
      lessonTitleLabel: "LESSON TITLE",
      lessonTitlePlaceholder: "Name this lesson",
      lessonSave: "SAVE LESSON",
      lessonContemplating: "CONTEMPLATING…",
      lessonUntitled: "Untitled lesson",
      lessonMore: "+{n} more",
      lessonAckFailed: "I could not respond just now. Name the lesson and save it — nothing is lost.",
      lessonPendingAck: "Received {files}. I cannot read its contents yet — this lesson will save now and I will come back to it.",
      lessonFileUnavailable: "file unavailable",
      lessonFileExpired: "This link has expired. Reopen the lesson to generate a new one.",
      classifyNext: "NEXT",
      addKbr: "ADD KBR",
      kbrRemoveSection: "Remove section",
      lessonTranscribing: "Transcribing…",
      lessonExtractFailed: "Could not be read",
      lessonUnsupportedFile: "This file type cannot be read yet.",
      captureTooLarge: "That recording is too large. Record a shorter clip.",
      addKbrSectionLabel: "SECTION",
      kbrSectionsCount: "{active} of {limit} sections active",
      kbrSectionsAtLimit: "Tier section limit reached",
      complianceAdd: "ADD COMPLIANCE ITEM",
      complianceAddTitle: "ADD COMPLIANCE ITEM",
      complianceIdentifierLabel: "STANDARD / CATEGORY",
      addContentTextLabel: "YOUR NOTES",
      addContentTextPlaceholder: "Enter text, notes, or observations…",
      addContentFileLabel: "ATTACH FILE",
      addContentFileDrop: "Drop a file here or click to browse",
      addContentLinkUrlLabel: "URL",
      addContentLinkTitleLabel: "TITLE (OPTIONAL)",
      addContentCaptureStart: "START RECORDING",
      addContentCaptureStop: "STOP RECORDING",
      addContentCaptureAudio: "AUDIO",
      addContentCaptureVideo: "VIDEO",
      addContentCapturePhoto: "PHOTOGRAPH",
      addContentCaptureChoose: "Choose what to capture",
      addContentCaptureRetake: "RETAKE",
      addContentCaptureUse: "USE THIS",
      addContentCaptureTimeLeft: "TIME LEFT",
      addContentCaptureMicError: "Cannot access microphone",
      addContentCaptureCameraError: "Cannot access camera",
      classifyTitle: "CLASSIFY CONTENT",
      classifyRoleLabel: "CONTENT ROLE",
      classifyActionLabel: "AI ACTION",
      classifyRoleEvidence: "Evidence",
      classifyRoleExample: "Example",
      classifyRoleExplanation: "Explanation",
      classifyActionComprehend: "Comprehend",
      classifyActionAnalyze: "Analyze",
      classifyActionQuery: "Query",
      classifyActionInstruction: "Instruction",
      classifySave: "SAVE",
      analyzePrompt: "What would you like me to analyze?",
      queryPrompt: "Enter your query",
      instructionPrompt: "What would you like me to do with this content?",
      eliminateConfirmTitle: "ELIMINATE ELEMENT",
      eliminateConfirmTitleMultiple: "ELIMINATE {n} ELEMENTS",
      eliminateConfirmBody: "This element will be permanently removed from this section. This action cannot be undone.",
      eliminateCheckLabel: "I understand these elements will be removed from the Chassis.",
      eliminateConfirmBodyMultiple: "{n} elements will be permanently removed from this section. This action cannot be undone.",
      eliminateConfirm: "ELIMINATE",
      eliminateCancel: "CANCEL",
      connectTitle: "CONNECT APP",
      connectNative: "CONNECT",
      connectPartial: "CONFIGURE",
      connectFallback: "AI-GUIDED SETUP",
      connectIdentify: "IDENTIFY SERVICE",
      connectModalTitle: "CONNECT",
      connectPrompt: "What application, service, or system would you like to connect to?",
      connectNativeSupported: "NATIVE SUPPORT DETECTED",
      connectNativeBody: "Click below to authorize via a secure OAuth popup. Once authorized, you can select the specific file or data source to connect.",
      connectNativeAuth: "AUTHORIZE & SELECT FILE",
      connectSave: "SAVE & CONNECT",
      connectFallbackBody: "I don't have built-in support for \"{service}\". Here are your options:",
      connectOptionApi: "DIRECT API",
      connectOptionApiDesc: "Provide your API endpoint and key. I will query it directly.",
      connectOptionJson: "JSON EXPORT",
      connectOptionJsonDesc: "Export your data as JSON and upload it. I will treat it as a connected snapshot.",
      connectOptionCustom: "CUSTOM SCRIPT",
      connectOptionCustomDesc: "Provide a connector script. I will execute it to retrieve the data.",
      assistedSuggesting: "Suggesting…",
      assistedFailed: "No suggestion this time — fill the fields in yourself.",
      assistedAccept: "USE ↵",
      consultantAnalyzing: "ANALYZING YOUR CHASSIS…",
      consultantPickOne: "SELECT AN ELEMENT TO ADD:",
      consultantRegenerate: "REGENERATE",
      consultantError: "Could not generate suggestions. Check your connection and try again.",
      consultantRetry: "RETRY",
      addContentFileDropMultiple: "Drop files here or click to browse — up to {n}",
      addContentFileMaxReached: "Maximum of {n} files reached",
      addContentLinkAdd: "ADD LINK",
      next: "NEXT",
      back: "BACK",
    },
    reFabricate: {
      title: "Re-Fabricate Chassis",
      contextNote: "Your current Chassis context will be used to build an even richer result.",
      originalInput: "ORIGINAL INPUT",
      editHint: "Edit or expand your input before re-fabricating.",
      selectType: "SELECT CHASSIS TYPE",
      confirm: "RE-FABRICATE",
    },
    chassisHistory: {
      title: "Chassis History",
      actionFabricated: "Fabricated",
      actionReFabricated: "Re-Fabricated",
      actionTuned: "Tuned",
      chassisType: "CHASSIS TYPE",
      beyondProfit: "BEYOND PROFIT",
      none: "None",
      noHistory: "No history yet.",
    },
    versions: {
      title: "Previous Versions",
      subtitle: "Every re-fabrication replaces this Chassis. The version it replaced is kept here.",
      current: "CURRENT",
      replacedOn: "Replaced",
      restore: "RESTORE",
      restoring: "Restoring…",
      confirmTitle: "Restore this version?",
      confirmBody: "This replaces what is on screen now. That content is kept too, so you can come back to it. No tokens are used.",
      confirmYes: "RESTORE",
      confirmNo: "CANCEL",
      none: "No previous versions. This Chassis has not been re-fabricated.",
      failed: "Could not restore that version.",
    },
    complianceLoadingStep: "BUILDING COMPLIANCE FRAMEWORK...",
    kbrSummaryLabel: "OBJECTIVES",
    prgLabel: "PRG",
    prgModalTitle: "POSSIBLE REVENUE GROWTH",
    prgModalDef: "Possible Revenue Growth (PRG) represents the potential upside if the KBRs in this area are applied correctly and targets are met. It is a directional indicator grounded in the business context — not a guarantee.",
    complianceCorp: "CORPORATE GOVERNANCE",
    complianceCorpAbbrev: "CORP",
    complianceReg: "REGULATORY & COMPLIANCE",
    complianceRegAbbrev: "REG.",
    complianceEvr: "EST. VALUE AT RISK",
    complianceEvrAbbrev: "EVR",
    complianceTabSub: "CORP · REG. · EVR",
    downloadLabel: "Download",
    downloadLoading: "Generating PDF…",
    downloadError: "Could not generate the PDF. Please try again.",
    share: {
      label: "Share",
      title: "SHARE CHASSIS",
      intro: "Anyone with this link can read this Chassis as JSON (ADDIS and BLIPS only). The original AI output is shared — Tune edits and Learning are NOT included.",
      empty: "No active share link.",
      create: "CREATE LINK",
      regenerate: "REGENERATE",
      revoke: "REVOKE",
      copy: "COPY",
      copied: "COPIED",
      expiry: "EXPIRES",
      newExpiry: "NEW EXPIRY",
      expiryNever: "Never",
      expiryInDays: "In {d} days",
      expired: "EXPIRED — regenerate to share again",
      close: "CLOSE",
    },
    eliminate: { label: "Eliminate" },
  },
  ES: {
    tagline: "BUSINESS OBSERVABILITY FRAMEWORK",
    bossLink: "una Boss.Technology",
    pageTitle: "Construir un Chass1s.",
    inputInstruction: "INGRESE UN TIPO DE NEGOCIO o NOMBRE DE EMPRESA ACTUAL, UBICACIÓN, SITIO WEB, OBJETIVOS, CONCEPTOS O CUALQUIER COMBINACIÓN — SEPARADOS POR COMAS.",
    deployHint: "⌘ + ENTER PARA DESPLEGAR · SE ABRE EN NUEVA PESTAÑA",
    startBtn: "INICIAR FABRICACIÓN",
    whatIsChs: "¿QUÉ ES CHASS1S?",
    chsDescription: "CHASS1S es el primer y único Business Observability (BO11Y) Framework del mundo — con el poder de Fabricar, Afinar e incluso Conducir cualquier negocio nuevo o existente, desde una heladería hasta una aerolínea. Por primera vez, la tecnología y el negocio se unifican en un solo vehículo poderoso — donde cada decisión, cada cambio y cada insight resuena con plena consciencia del conjunto. A través de Business Observability, impulsada por Applied AI, CHASS1S convierte la complejidad de dirigir un negocio en algo observable, medible y accionable. El Framework moderno para Empresas Rápidas y Negocios en Tiempo Real.",
    chsCreditBoss: { prefix: "CHASS1S es traído a ti por ", name: "Boss.Technology", suffix: " — Premium Business Observability Builder, Tuner y Brand con base en Latinoamérica." },
    chsCreditFederico: { prefix: "Creado por ", name: "Federico Lara", suffix: " — líder de pensamiento en Business Observability, autor de Six Steps to Achieve Business Observability, creador de Metric Monetization, y ex ejecutivo en New Relic y Dynatrace." },
    selectDepth: "SELECCIONAR PROFUNDIDAD DEL CHASSIS",
    tabs: { intro: "INTRO", introSub: "Perfil del Negocio", addis: "ADDIS", addisSub: "Capa Tecnológica", blips: "BLIPS", blipsSub: "Capa Empresarial", kbrs: "KBRs", kbrsSub: "Key Business Results", compliance: "COMPLIANCE", complianceSub: "CORP · REG. · EVR" },
    expandAll: "EXPANDIR TODO", collapseAll: "COLAPSAR TODO",
    sections: "SECCIONES", items: "ELEMENTOS",
    businessProfile: "PERFIL DEL NEGOCIO", whyChassis: "CHASSIS", keyValuePoints: "PUNTOS DE VALOR CLAVE", frameworkApplied: "CHASSIS APLICADO",
    addisDesc: "Mapea cada herramienta tecnológica, plataforma, sistema y componente de infraestructura del que depende este negocio.",
    blipsDesc: "Mapea cada función empresarial y las fuentes de datos observables que conectan el rendimiento tecnológico con los resultados del negocio.",
    kbrTitle: "Key Business Results", kbrsAcross: "KBRs ACROSS", businessAreas: "BUSINESS AREAS",
    metric: "MÉTRICA", target: "OBJETIVO",
    newChassis: "NUEVO CHASSIS",
    loadingTitle: "PROCESANDO",
    loadingSteps: ["ANALIZANDO TIPO DE NEGOCIO...", "MAPEANDO CAPA TECNOLÓGICA ADDIS...", "CONSTRUYENDO CHASSIS EMPRESARIAL BLIPS...", "GENERANDO RESULTADOS CLAVE DEL NEGOCIO...", "FABRICANDO CHASSIS..."],
    fabricatingPrefix: "FABRICANDO",
    charmingPhrases: [
      "Esto va rápido — prepárate.",
      "¿Sigues aquí? Bien. Nosotros también. Todo va bien.",
      "Estírate un poco. Estaremos listos cuando tú lo estés.",
      "Esto toma un momento. Un buen momento — como el de un buen café expreso.",
      "Mientras esperas, ve a abrazar a una mascota... no tiene que ser la tuya.",
      "Puede tomar unos minutos — ve y pide esa bebida complicada que tanto te gusta.",
      "Estamos construyendo algo a tu medida, específico, tuyo. Las cosas buenas toman tiempo.",
      "Seguimos. Este es nuestro trabajo más profundo. Ve por algo de comer. Te lo mereces.",
    ],
    errorTitle: "Algo salió mal.", tryAgain: "INTENTAR DE NUEVO",
    errorBpNotSaved: "Beyond Profit se generó pero no se pudo guardar. Copia lo que necesites antes de recargar.",
    tableHeaders: ["Elemento", "Tipo", "Descripción", "Int/Ext", "Entorno", "Datos"],
    tableHeadersBlips: ["Elemento", "Fuente", "Tipo", "Descripción", "Int/Ext", "Entorno", "Datos"],
    noItems: "No se generaron elementos.",
    tiers: [
      { id: "compact", label: "Compacto", description: "Visión esencial. Elementos básicos de ADDIS y BLIPS con KBRs enfocados. Ideal para evaluaciones rápidas." },
      { id: "midsize", label: "Mediano", description: "Mayor profundidad con más contexto. Más elementos, descripciones completas y factores del mundo real ampliados." },
      { id: "executive", label: "Ejecutivo", description: "Análisis exhaustivo con contexto detallado, cobertura del mundo real y KBRs enriquecidos con benchmarks de la industria." },
      { id: "luxury", label: "Lujo", description: "Inteligencia empresarial de nivel superior. Máxima profundidad, análisis de impacto narrativo, registro de riesgos y victorias rápidas." },
    ],
    examples: [
      "Häagen-Dazs, Regent Street Londres UK, https://www.haagen-dazs.co.uk/, Aumentar ventas un 20% en meses de invierno.",
      "Taller de motos, Medellín Colombia Laureles, Añadir servicios de renta y tuning personalizado, Presupuesto $2,000 USD.",
      "Mercado Libre, https://www.mercadolibre.com/",
      "Hotel Boutique, Cartagena Colombia, Expandir reservas de viajeros internacionales, Lanzar programa de fidelización.",
      "Tesla, https://www.tesla.com/, Optimizar operaciones de centros de servicio, Reducir tiempos de espera un 30%.",
      "Farmacia Independiente, Miami Florida, Competir con grandes cadenas, Lanzar servicio de domicilios y telemedicina.",
      "Gimnasio CrossFit, Brooklyn Nueva York, Crecer base de miembros, Lanzar programa de entrenamiento en línea.",
      "Firma de Derecho Familiar, Ciudad de México, Atraer clientes de alto valor, Estrategia de presencia digital.",
    ],
    beyondProfit: "BEYOND PROFIT",
    beyondProfitSub: "Opcional",
    beyondProfitDesc: "Seleccione las iniciativas relevantes para este negocio. Los resultados aparecerán como una pestaña dedicada.",
    beyondProfitTab: "Beyond Profit",
    beyondProfitTabSub: "Perspectivas Legales, Sociales y Regulatorias",
    complianceSectionGovernance: "GOBIERNO CORPORATIVO",
    complianceSectionRegulatory: "CUMPLIMIENTO REGULATORIO E INDUSTRIAL",
    complianceSectionEVR:        "VALOR ESTIMADO EN RIESGO",
    complianceImplementation:    "IMPLEMENTACIÓN",
    compliancePerformance:       "DESEMPEÑO",
    complianceCompliance:        "CUMPLIMIENTO",
    complianceAnnualRange:       "RANGO DE EXPOSICIÓN ANUAL",
    compliancePerIncident:       "COSTO POR INCIDENTE",
    complianceRefs:              "ADDIS · BLIPS",
    complianceFabNote:           "Sugerido — confirmar con evidencia en Tune",
    bpOptions: { CSR: "RSE", ESG: "ESG", DEI: "DEI", TBL: "TBL", Sustainability: "SUS" },
    bpDefinitions: {
      CSR: "RSE — Responsabilidad Social Empresarial",
      ESG: "ESG — Ambiental, Social y Gobernanza",
      DEI: "DEI — Diversidad, Equidad e Inclusión",
      TBL: "TBL — Triple Línea de Base",
      Sustainability: "SUS — Sostenibilidad",
    },
    useTokens: "USAR",
    tokensPer: "1 TOKEN POR",
    insufficientTokens: "TOKENS INSUFICIENTES",
    required: "REQUERIDOS",
    bpLabels: { legal: "LEGAL", social: "SOCIAL", regulatory: "REGULATORIO", news: "NOTICIAS Y DESARROLLOS", suggestions: "SUGERENCIAS" },
    bp: { analyzing: "ANALIZANDO", gatheringContext: "RECOPILANDO CONTEXTO LEGAL Y REGULATORIO...", generatingInsights: "GENERANDO INSIGHTS Y SUGERENCIAS...", errorMsg: "No se pudieron generar los insights de Beyond Profit." },
    pdfControlled: "CONTROLADO",
    pdfUncontrolled: "NO CONTROLADO",
    sectionInfo: {
      Apps: "Aplicaciones de software específicas que el negocio usa diariamente — plataformas SaaS, apps móviles/web, herramientas de productividad y aplicaciones especializadas de la industria.",
      Data: "Bases de datos, almacenes de datos, herramientas de BI y plataformas de almacenamiento — la tecnología que guarda y procesa los datos del negocio.",
      Dev: "Herramientas de desarrollo, control de versiones, pipelines CI/CD, APIs consumidas y herramientas de despliegue — el stack tecnológico que construye y mantiene el software.",
      Infrastructure: "Servidores, plataformas cloud, redes, dispositivos IoT, CDNs y hardware — la base física y virtual sobre la que todo opera.",
      Systems: "Plataformas empresariales que orquestan operaciones — ERP, CRM, WMS, MES y sistemas SIEM.",
      BizOps: "Operaciones diarias del negocio, procesos administrativos, gestión financiera y gobernanza organizacional.",
      Logistics: "Cadena de suministro, transporte, redes de entrega, distribución y operaciones de fulfillment.",
      Inventory: "Gestión de existencias, operaciones de almacén, seguimiento de productos y procesos de aprovisionamiento.",
      Production: "Fabricación, entrega de servicios, control de calidad y procesos que crean el producto o servicio.",
      Sales: "Generación de ingresos, adquisición de clientes, estrategia de precios, campañas de marketing y gestión de relaciones con clientes.",
    },
    errorEmailNotConfirmed: "Por favor confirma tu dirección de email antes de generar. Revisa tu bandeja de entrada.",
    errorConnectionTimeout: "La conexión tardó más de 60 segundos en establecerse. Intenta de nuevo.",
    errorInsufficientBalance: "Saldo de tokens insuficiente.",
    errorAccountNotFound: "Cuenta no encontrada.",
    errorSaveChassis: "No se pudo guardar tu Chassis. No se cobraron tokens.",
    auth: {
      signInTitle:    "Iniciar Sesión en CHASS1S",
      signUpTitle:    "Crear Tu Cuenta",
      resetTitle:     "Restablecer Tu Contraseña",
      signInTab:      "INICIAR SESIÓN",
      signUpTab:      "CREAR CUENTA",
      forgotTab:      "RESTABLECER",
      emailLabel:     "CORREO ELECTRÓNICO",
      passwordLabel:  "CONTRASEÑA",
      redirecting:    "REDIRIGIENDO...",
      processing:     "PROCESANDO...",
      sending:        "ENVIANDO...",
      sendReset:      "ENVIAR EMAIL DE RESTABLECIMIENTO",
      backToSignIn:   "Volver al Inicio de Sesión",
      forgotLink:     "¿Olvidaste tu contraseña?",
      signUpSuccess:  "¡Cuenta creada! Revisa tu email para confirmar.",
      resetSuccess:   "Email de restablecimiento enviado. Revisa tu bandeja.",
      freeTokens:     "Las cuentas nuevas reciben 10 TOKENS GRATIS — sin tarjeta de crédito.",
      orContinueWith: "O CONTINUAR CON",
    },
    // ── Account Menu ──
    menuSignedInAs: "SESIÓN COMO",
    menuWorkspace: "ESPACIO DE TRABAJO",
    menuPersonal: "Personal",
    menuAddWorkspace: "+ Espacio de Trabajo",
    menuChassis: "CHASSIS",
    menuTokenBalance: "SALDO DE TOKENS",
    menuBuyMore: "+ Comprar Más",
    menuLanguage: "IDIOMA",
    menuSignOut: "CERRAR SESIÓN",
    // ── Workspace configuration & deletion ──
    workspaceConfigEyebrow: "ESPACIO · CONFIGURACIÓN",
    workspaceConfigure: "Configurar espacio",
    workspaceAddMember: "AÑADIR MIEMBRO",
    workspaceDelete: "Eliminar espacio",
    workspaceDeleteTitle: "⚠ ELIMINAR ESPACIO",
    workspaceDeleteBody: "Estás a punto de eliminar permanentemente {name}. Esta acción no se puede deshacer.",
    workspaceDeleteImpact: "ESTO AFECTARÁ:",
    workspaceDeleteChassis: "{n} chassis serán eliminados permanentemente",
    workspaceDeleteMembers: "{n} miembros perderán el acceso",
    workspaceDeleteAck: "Entiendo que este espacio y todos sus chassis serán eliminados permanentemente.",
    workspaceDeleteConfirm: "ELIMINAR PERMANENTEMENTE",
    workspaceDeleteCancel: "CANCELAR",
    chassisDeleteNotOwner: "Solo quien creó este Chassis puede eliminarlo.",
    workspaceInviteNoAccount: "No hay ninguna cuenta CHASS1S con ese correo. Pídele que se registre primero.",
    workspaceInviteAlreadyMember: "Esa persona ya es miembro de este espacio.",
    workspaceInviteAdded: "{email} añadido como {role}.",
    workspaceRoleMember: "Miembro",
    workspaceRoleCoOwner: "Co-Propietario",
    workspaceInviteMailFailed: "Miembro añadido, pero no se pudo enviar el correo de notificación.",
    // ── Settings & Support ──
    menuSettings: "Configuración",
    menuSupport: "Soporte",
    settingsTitle: "Configuración de Cuenta",
    settingsSectionProfile: "INFORMACIÓN DE PERFIL",
    settingsSave: "GUARDAR CAMBIOS",
    settingsSaving: "GUARDANDO...",
    settingsSaved: "✓ Guardado",
    settingsSectionSecurity: "SEGURIDAD",
    settingsNewEmail: "NUEVO CORREO ELECTRÓNICO",
    settingsUpdateEmail: "ACTUALIZAR EMAIL",
    settingsCurrentPassword: "CONTRASEÑA ACTUAL",
    settingsNewPassword: "NUEVA CONTRASEÑA",
    settingsConfirmPassword: "CONFIRMAR NUEVA CONTRASEÑA",
    settingsUpdatePassword: "ACTUALIZAR CONTRASEÑA",
    settingsOAuthNoPassword: "El inicio de sesión con contraseña no está disponible para tu cuenta. Iniciaste sesión con un proveedor social.",
    settingsSectionConnected: "CUENTAS CONECTADAS",
    settingsSectionDanger: "CERRAR CUENTA",
    settingsDangerWarning: "Tu cuenta quedará programada para eliminación en 30 días. Puedes reactivarla iniciando sesión antes de esa fecha.",
    settingsDangerPrompt: "Escribe DELETE para confirmar",
    settingsDeactivateBtn: "DESACTIVAR CUENTA",
    settingsDeactivated: "Cuenta desactivada. Serás desconectado.",
    settingsDangerShow: "Mostrar opciones",
    settingsDisplayName: "NOMBRE",
    settingsCountry: "PAÍS",
    settingsSelectPlaceholder: "— Seleccionar —",
    settingsAgeRange: "RANGO DE EDAD",
    settingsRoles: "TU(S) ROL(ES)",
    settingsEmailPasswordHint: "Ingresa tu contraseña actual para continuar.",
    settingsCurrentPwdPh: "Contraseña actual",
    settingsShow: "mostrar",
    settingsHide: "ocultar",
    settingsVerifyPassword: "VERIFICAR CONTRASEÑA",
    settingsOtpHint: "Se envió un código a {email}. Ingrésalo abajo.",
    settingsOtpPlaceholder: "Código de 6 dígitos",
    settingsVerifyCode: "VERIFICAR CÓDIGO",
    settingsCancel: "Cancelar",
    settingsIdentityVerified: "Identidad verificada. Ingresa tu nuevo correo.",
    settingsNewEmailPlaceholder: "Nueva dirección de correo",
    settingsSendConfirmation: "ENVIAR CONFIRMACIÓN",
    settingsConfirmationSent: "Confirmación enviada a {email}. Revisa tu bandeja.",
    settingsDone: "LISTO",
    settingsLinkingNote: "Vincular / desvincular no disponible en esta versión.",
    settingsChangePassword: "CAMBIAR CONTRASEÑA",
    settingsPwdUpdated: "Actualizado",
    settingsErrIncorrectPwd: "Contraseña incorrecta. Inténtalo de nuevo.",
    settingsErrNetwork: "Error de red. Por favor intenta de nuevo.",
    settingsErrPwdMatch: "Las contraseñas no coinciden",
    settingsErrPwdLength: "Mínimo 6 caracteres",
    settingsErrCurrentPwd: "La contraseña actual es incorrecta",
    settingsErrInvalidCode: "Código inválido o caducado.",
    supportTitle: "Contactar Soporte",
    supportCategoryLabel: "CATEGORÍA DEL PROBLEMA",
    supportCategories: ["Facturación y Tokens", "Problema Técnico", "Acceso a Cuenta", "Calidad de Generación", "Solicitud de Función", "Otro"],
    supportCategoryPlaceholder: "— Seleccionar categoría —",
    supportDescriptionLabel: "DESCRIPCIÓN",
    supportDescriptionPlaceholder: "Describe tu problema en detalle (mínimo 20 caracteres)...",
    supportAttachLabel: "ADJUNTO (opcional)",
    supportChooseFile: "ELEGIR ARCHIVO",
    supportFileSizeError: "El archivo debe ser menor de 5MB",
    supportFileTypeError: "Solo se aceptan imágenes y archivos PDF",
    supportSubmit: "ENVIAR TICKET",
    supportSubmitting: "ENVIANDO...",
    supportSuccessTitle: "Ticket Enviado",
    supportSuccessMsg: "Te responderemos en 24–48 horas. Tu número de ticket es:",
    supportAttachFailed: "Tu incidencia se envió, pero el archivo no se pudo adjuntar. Responde al correo de confirmación para enviarlo.",
    supportClose: "CERRAR",
    tokenBreadcrumb: "CHASS1S - COMPRA DE TOKENS",
    tokenTitle: "Comprar Tokens",
    tokenBalance: "Saldo actual:",
    tokenBalanceSuffix: "tokens",
    tokenDepositLabel: "MONTO DE DEPÓSITO (USD)",
    tokenMinMax: "Mínimo $25.00 - Máximo $1,000.00",
    tokenBreakdownLabel: "DESGLOSE DE TOKENS",
    tokenBaseTokens: "Tokens base ($1 = 1 token)",
    tokenVolumeBonus: "Bonificación por volumen",
    tokenTotal: "TOTAL DE TOKENS",
    tokenPromoLabel: "CÓDIGO PROMOCIONAL (OPCIONAL)",
    tokenPromoPlaceholder: "Ingresa el código",
    tokenApply: "APLICAR",
    tokenPromoError: "Código promocional inválido.",
    tokenPromoNetworkErr: "No se pudo validar el código.",
    tokenProceedBtn: "PROCEDER A STRIPE",
    tokenCostLabel: "REFERENCIA DE COSTOS CHASS1S",
    tokenFooter: "Pagos procesados de forma segura por Stripe - Los tokens no vencen - No reembolsable",
    historyBreadcrumb: "CHASS1S - HISTORIAL",
    historyTitle: "Mis Chass1s",
    historyCount: "{n} Chass1s generados",
    historyLoading: "CARGANDO...",
    historyEmpty: "AUN SIN CHASS1S",
    historyEmptyDesc: "Genera tu primer Chass1s y aparecerá aquí.",
    historyUnnamed: "Chass1s sin nombre",
    historyOpen: "ABRIR",
    workspaceCreateTitle: "Crear Espacio de Trabajo",
    workspaceCreateDesc: "Colabora con tu equipo y comparte un grupo de tokens. Serás el Propietario.",
    workspaceNameLabel: "NOMBRE DEL ESPACIO",
    workspaceNamePh: "ej. Acme Corp, Equipo de Marketing...",
    workspaceCreating: "CREANDO...",
    workspaceCreateBtn: "CREAR ESPACIO",
    workspaceCreateFooter: "Co-propietarios y Miembros pueden ser invitados desde la configuración del espacio después de crearlo.",
    workspaceCreateError: "No se pudo crear el espacio",
    modeSelector: {
      fabricate: "Fabricate",
      tune: "Tune",
      drive: "Drive",
      go: "IR",
      comingSoon: "Próximamente",
    },
    tune: {
      lessonsColumn: "LECCIONES",
      payModalTitle: "ENTRAR MODO TUNE",
      payModalBody: "Entrar en modo Tune te permite editar cada elemento de este Chassis. Una vez pagado, alterna libremente hasta Refabricar.",
      payConfirm: "USAR {n} TOKENS Y ENTRAR EN TUNE",
      balance: "SALDO",
      modeOn: "TUNE: ACTIVADO",
      clickToExit: "CLIC PARA SALIR",
      activeIndicatorTooltip: "Modo Tune activo",
      editHistoryTitle: "HISTORIAL DE EDICIONES",
      loadingHistory: "CARGANDO HISTORIAL...",
      noEditHistory: "Sin historial de ediciones para este elemento.",
      revertButton: "REVERTIR A ESTA VERSIÓN",
      pctOnRefabricate: "PORCENTAJES RECALCULADOS EN REFABRICACIÓN",
      downgradeTitleWarning: "⚠ REDUCCIÓN DE NIVEL — MENOR PROFUNDIDAD",
      downgradeBody: "Reducir el nivel disminuirá el número de elementos ADDIS, BLIPS, KBRs y el detalle de Cumplimiento en tu Chassis refabricado. Las ediciones de Tune confirmadas seguirán respetándose como verdad base, pero el menor presupuesto de tokens significa que algunas áreas serán condensadas. Puedes volver a subir de nivel refabricando en un nivel superior.",
      addElement: "AÑADIR ELEMENTO",
      teach: "ENSEÑAR",
      addElementTitle: "AÑADIR ELEMENTO",
      addElementManual: "ENTRADA MANUAL",
      addElementAssisted: "ASISTIDO",
      addElementConsultant: "VISTA CONSULTOR",
      addElementNameLabel: "NOMBRE DEL ELEMENTO",
      addElementTypeLabel: "TIPO",
      addElementDataLabel: "DATOS",
      addElementTitleLabel: "TÍTULO",
      addElementDescLabel: "DESCRIPCIÓN",
      addElementMetricLabel: "MÉTRICA",
      addElementTargetLabel: "OBJETIVO",
      addElementInExLabel: "INT / EXT",
      addElementEnvLabel: "ENTORNO",
      addElementSourceLabel: "FUENTE",
      addElementSave: "GUARDAR ELEMENTO",
      addElementAssistedPrompt: "Describe lo que quieres añadir y la IA sugerirá elementos coincidentes.",
      addElementGenerate: "GENERAR SUGERENCIAS",
      addElementConsultantPrompt: "Describe el contexto del negocio y la IA propondrá elementos desde una perspectiva consultora.",
      teachTitle: "ENSEÑAR",
      saveContentError: "No se pudo guardar este contenido.",
      addContentInput: "TEXTO",
      addContentAttach: "ADJUNTAR",
      addContentCapture: "CAPTURAR",
      addContentLink: "ENLACE",
      addContentConnect: "CONECTAR",
      teachTooltip: "Enseña a CHASS1S sobre los elementos seleccionados",
      lessons: "LECCIONES",
      lessonTitleLabel: "TÍTULO DE LA LECCIÓN",
      lessonTitlePlaceholder: "Nombra esta lección",
      lessonSave: "GUARDAR LECCIÓN",
      lessonContemplating: "CONTEMPLANDO…",
      lessonUntitled: "Lección sin título",
      lessonMore: "+{n} más",
      lessonAckFailed: "No pude responder en este momento. Nombra la lección y guárdala — no se pierde nada.",
      lessonPendingAck: "Recibí {files}. Aún no puedo leer su contenido — esta lección se guardará ahora y volveré a ella.",
      lessonFileUnavailable: "archivo no disponible",
      lessonFileExpired: "Este enlace ha caducado. Vuelve a abrir la lección para generar uno nuevo.",
      classifyNext: "SIGUIENTE",
      addKbr: "AÑADIR KBR",
      kbrRemoveSection: "Quitar sección",
      lessonTranscribing: "Transcribiendo…",
      lessonExtractFailed: "No se pudo leer",
      lessonUnsupportedFile: "Este tipo de archivo aún no se puede leer.",
      captureTooLarge: "Esa grabación es demasiado grande. Graba un clip más corto.",
      addKbrSectionLabel: "SECCIÓN",
      kbrSectionsCount: "{active} de {limit} secciones activas",
      kbrSectionsAtLimit: "Límite de secciones del plan alcanzado",
      complianceAdd: "AÑADIR ELEMENTO",
      complianceAddTitle: "AÑADIR ELEMENTO DE CUMPLIMIENTO",
      complianceIdentifierLabel: "ESTÁNDAR / CATEGORÍA",
      addContentTextLabel: "TUS NOTAS",
      addContentTextPlaceholder: "Escribe texto, notas u observaciones…",
      addContentFileLabel: "ADJUNTAR ARCHIVO",
      addContentFileDrop: "Arrastra un archivo aquí o haz clic para buscar",
      addContentLinkUrlLabel: "URL",
      addContentLinkTitleLabel: "TÍTULO (OPCIONAL)",
      addContentCaptureStart: "INICIAR GRABACIÓN",
      addContentCaptureStop: "DETENER GRABACIÓN",
      addContentCaptureAudio: "AUDIO",
      addContentCaptureVideo: "VIDEO",
      addContentCapturePhoto: "FOTOGRAFÍA",
      addContentCaptureChoose: "Elige qué capturar",
      addContentCaptureRetake: "REINTENTAR",
      addContentCaptureUse: "USAR ESTO",
      addContentCaptureTimeLeft: "TIEMPO RESTANTE",
      addContentCaptureMicError: "No se puede acceder al micrófono",
      addContentCaptureCameraError: "No se puede acceder a la cámara",
      classifyTitle: "CLASIFICAR CONTENIDO",
      classifyRoleLabel: "ROL DEL CONTENIDO",
      classifyActionLabel: "ACCIÓN IA",
      classifyRoleEvidence: "Evidencia",
      classifyRoleExample: "Ejemplo",
      classifyRoleExplanation: "Explicación",
      classifyActionComprehend: "Comprender",
      classifyActionAnalyze: "Analizar",
      classifyActionQuery: "Consultar",
      classifyActionInstruction: "Instrucción",
      classifySave: "GUARDAR",
      analyzePrompt: "¿Qué deseas que analice?",
      queryPrompt: "Ingresa tu consulta",
      instructionPrompt: "¿Qué deseas que haga con este contenido?",
      eliminateConfirmTitle: "ELIMINAR ELEMENTO",
      eliminateConfirmTitleMultiple: "ELIMINAR {n} ELEMENTOS",
      eliminateConfirmBody: "Este elemento será eliminado permanentemente de esta sección. Esta acción no se puede deshacer.",
      eliminateCheckLabel: "Entiendo que estos elementos serán removidos del Chassis.",
      eliminateConfirmBodyMultiple: "{n} elementos serán eliminados permanentemente de esta sección. Esta acción no se puede deshacer.",
      eliminateConfirm: "ELIMINAR",
      eliminateCancel: "CANCELAR",
      connectTitle: "CONECTAR APLICACIÓN",
      connectNative: "CONECTAR",
      connectPartial: "CONFIGURAR",
      connectFallback: "CONFIGURACIÓN GUIADA POR IA",
      connectIdentify: "IDENTIFICAR SERVICIO",
      connectModalTitle: "CONECTAR",
      connectPrompt: "¿Con qué aplicación, servicio o sistema deseas conectarte?",
      connectNativeSupported: "SOPORTE NATIVO DETECTADO",
      connectNativeBody: "Haz clic abajo para autorizar mediante un popup OAuth seguro. Una vez autorizado, podrás seleccionar el archivo o fuente de datos.",
      connectNativeAuth: "AUTORIZAR Y SELECCIONAR ARCHIVO",
      connectSave: "GUARDAR Y CONECTAR",
      connectFallbackBody: "No tengo soporte nativo para \"{service}\". Aquí tus opciones:",
      connectOptionApi: "API DIRECTA",
      connectOptionApiDesc: "Proporciona tu endpoint y clave de API. La consultaré directamente.",
      connectOptionJson: "EXPORTACIÓN JSON",
      connectOptionJsonDesc: "Exporta tus datos como JSON y súbelos. Los trataré como una instantánea conectada.",
      connectOptionCustom: "SCRIPT PERSONALIZADO",
      connectOptionCustomDesc: "Proporciona un script conector. Lo ejecutaré para recuperar los datos.",
      assistedSuggesting: "Sugiriendo…",
      assistedFailed: "Sin sugerencia esta vez — rellena los campos tú mismo.",
      assistedAccept: "USAR ↵",
      consultantAnalyzing: "ANALIZANDO TU CHASSIS…",
      consultantPickOne: "SELECCIONA UN ELEMENTO A AGREGAR:",
      consultantRegenerate: "REGENERAR",
      consultantError: "No se pudieron generar sugerencias. Verifica tu conexión e inténtalo de nuevo.",
      consultantRetry: "REINTENTAR",
      addContentFileDropMultiple: "Arrastra archivos aquí o haz clic para buscar — hasta {n}",
      addContentFileMaxReached: "Máximo de {n} archivos alcanzado",
      addContentLinkAdd: "AÑADIR ENLACE",
      next: "SIGUIENTE",
      back: "ATRÁS",
    },
    reFabricate: {
      title: "Re-Fabricate Chassis",
      contextNote: "Tu Chass1s actual será usado para construir un resultado aún más rico.",
      originalInput: "ENTRADA ORIGINAL",
      editHint: "Edita o amplía tu entrada antes de re-fabricar.",
      selectType: "SELECCIONAR TIPO",
      confirm: "RE-FABRICATE",
    },
    chassisHistory: {
      title: "Historial del Chass1s",
      actionFabricated: "Fabricado",
      actionReFabricated: "Re-Fabricado",
      actionTuned: "Afinado",
      chassisType: "TIPO DE CHASS1S",
      beyondProfit: "BEYOND PROFIT",
      none: "Ninguno",
      noHistory: "Sin historial aún.",
    },
    versions: {
      title: "Versiones anteriores",
      subtitle: "Cada re-fabricación reemplaza este Chassis. Aquí se guarda la versión que reemplazó.",
      current: "ACTUAL",
      replacedOn: "Reemplazada",
      restore: "RESTAURAR",
      restoring: "Restaurando…",
      confirmTitle: "¿Restaurar esta versión?",
      confirmBody: "Esto reemplaza lo que ves ahora. Ese contenido también se guarda, así que puedes volver a él. No se gastan tokens.",
      confirmYes: "RESTAURAR",
      confirmNo: "CANCELAR",
      none: "No hay versiones anteriores. Este Chassis no se ha re-fabricado.",
      failed: "No se pudo restaurar esa versión.",
    },
    complianceLoadingStep: "CONSTRUYENDO MARCO DE CUMPLIMIENTO...",
    kbrSummaryLabel: "OBJETIVOS",
    prgLabel: "PRG",
    prgModalTitle: "CRECIMIENTO DE INGRESOS POSIBLE",
    prgModalDef: "El Crecimiento de Ingresos Posible (PRG) representa el potencial si los KBRs se aplican correctamente. Es un indicador direccional basado en el contexto del negocio — no una garantía.",
    complianceCorp: "GOBERNANZA CORPORATIVA",
    complianceCorpAbbrev: "CORP",
    complianceReg: "REGULATORIO",
    complianceRegAbbrev: "REG.",
    complianceEvr: "VALOR EN RIESGO",
    complianceEvrAbbrev: "EVR",
    complianceTabSub: "CORP · REG. · EVR",
    downloadLabel: "Descargar",
    downloadLoading: "Generando PDF…",
    downloadError: "No se pudo generar el PDF. Inténtalo de nuevo.",
    share: {
      label: "Compartir",
      title: "COMPARTIR CHASSIS",
      intro: "Cualquier persona con este enlace puede leer este Chassis como JSON (solo ADDIS y BLIPS). Se comparte la salida original de la IA — las ediciones de Tune y Learning NO se incluyen.",
      empty: "No hay un enlace activo.",
      create: "CREAR ENLACE",
      regenerate: "REGENERAR",
      revoke: "REVOCAR",
      copy: "COPIAR",
      copied: "COPIADO",
      expiry: "EXPIRA",
      newExpiry: "NUEVA EXPIRACIÓN",
      expiryNever: "Nunca",
      expiryInDays: "En {d} días",
      expired: "EXPIRADO — regenera para volver a compartir",
      close: "CERRAR",
    },
    eliminate: { label: "Eliminar" },
  },
  FR: {
    tagline: "BUSINESS OBSERVABILITY FRAMEWORK",
    bossLink: "une Boss.Technology",
    pageTitle: "Construire un Chass1s.",
    inputInstruction: "SAISISSEZ UN TYPE D'ENTREPRISE ou NOM D'ENTREPRISE ACTUEL, LIEU, SITE WEB, OBJECTIFS, CONCEPTS OU TOUTE COMBINAISON — SÉPARÉS PAR DES VIRGULES.",
    deployHint: "⌘ + ENTRÉE POUR DÉPLOYER · OUVRE DANS UN NOUVEL ONGLET",
    startBtn: "COMMENCER LA FABRICATION",
    whatIsChs: "QU'EST-CE QUE CHASS1S?",
    chsDescription: "CHASS1S est le premier et unique Business Observability (BO11Y) Framework au monde — avec le pouvoir de Fabriquer, Affiner et même Piloter toute entreprise nouvelle ou existante, d'un glacier à une compagnie aérienne. Pour la première fois, la technologie et l'entreprise sont unifiées en un seul véhicule puissant — où chaque décision, chaque changement et chaque insight se répercute avec une pleine conscience de l'ensemble. À travers Business Observability, propulsée par Applied AI, CHASS1S transforme la complexité de gérer une entreprise en quelque chose d'observable, mesurable et actionnable. Le Framework moderne pour les Entreprises Rapides et les Businesses en Temps Réel.",
    chsCreditBoss: { prefix: "CHASS1S vous est proposé par ", name: "Boss.Technology", suffix: " — Premium Business Observability Builder, Tuner et Brand basé en Amérique Latine." },
    chsCreditFederico: { prefix: "Créé par ", name: "Federico Lara", suffix: " — leader d'opinion en Business Observability, auteur de Six Steps to Achieve Business Observability, créateur de Metric Monetization, et ancien dirigeant chez New Relic et Dynatrace." },
    selectDepth: "SÉLECTIONNER LA PROFONDEUR DU CHASSIS",
    tabs: { intro: "INTRO", introSub: "Profil de l'Entreprise", addis: "ADDIS", addisSub: "Couche Technologique", blips: "BLIPS", blipsSub: "Couche Métier", kbrs: "KBRs", kbrsSub: "Key Business Results", compliance: "COMPLIANCE", complianceSub: "CORP · RÉG. · EVR" },
    expandAll: "TOUT DÉVELOPPER", collapseAll: "TOUT RÉDUIRE",
    sections: "SECTIONS", items: "ÉLÉMENTS",
    businessProfile: "PROFIL DE L'ENTREPRISE", whyChassis: "CHASSIS", keyValuePoints: "POINTS DE VALEUR CLÉS", frameworkApplied: "CHASSIS APPLIQUÉ",
    addisDesc: "Cartographie chaque outil technologique, plateforme, système et composant d'infrastructure dont dépend cette entreprise.",
    blipsDesc: "Cartographie chaque fonction métier et les sources de données observables qui relient la performance technologique aux résultats commerciaux.",
    kbrTitle: "Key Business Results", kbrsAcross: "KBRs ACROSS", businessAreas: "BUSINESS AREAS",
    metric: "MÉTRIQUE", target: "OBJECTIF",
    newChassis: "NOUVEAU CHASSIS",
    loadingTitle: "TRAITEMENT EN COURS",
    loadingSteps: ["ANALYSE DU TYPE D'ENTREPRISE...", "CARTOGRAPHIE DE LA COUCHE ADDIS...", "CONSTRUCTION DU CHASSIS BLIPS...", "GÉNÉRATION DES RÉSULTATS CLÉS...", "FABRICATION DU CHASSIS..."],
    fabricatingPrefix: "FABRICATION",
    charmingPhrases: [
      "Ça avance vite — préparez-vous.",
      "Toujours là ? Bien. Nous aussi. Tout se passe bien.",
      "Étirez-vous un peu. Nous serons prêts quand vous l'êtes.",
      "Cela prend un moment. Un bon moment — comme celui d'un bon espresso.",
      "En attendant, allez câliner un animal... il ne doit pas être le vôtre.",
      "Cela peut prendre quelques minutes — commandez cette boisson trop compliquée que vous adorez.",
      "Nous construisons quelque chose sur mesure, précis, qui vous appartient. Les bonnes choses prennent du temps.",
      "On continue. C'est notre travail le plus approfondi. Allez vous chercher une collation. Vous le méritez.",
    ],
    errorTitle: "Une erreur s'est produite.", tryAgain: "RÉESSAYER",
    errorBpNotSaved: "Beyond Profit a été généré mais n'a pas pu être enregistré. Copiez ce dont vous avez besoin avant de recharger.",
    tableHeaders: ["Élément", "Type", "Description", "Int/Ext", "Environnement", "Données"],
    tableHeadersBlips: ["Élément", "Source", "Type", "Description", "Int/Ext", "Environnement", "Données"],
    noItems: "Aucun élément généré.",
    tiers: [
      { id: "compact", label: "Compact", description: "Vue d'ensemble essentielle. Éléments ADDIS et BLIPS principaux avec des KBRs ciblés. Idéal pour les évaluations rapides." },
      { id: "midsize", label: "Moyen", description: "Profondeur enrichie avec plus de contexte. Plus d'éléments, descriptions complètes et facteurs réels élargis." },
      { id: "executive", label: "Exécutif", description: "Analyse complète avec contexte détaillé, couverture approfondie et KBRs enrichis avec des benchmarks sectoriels." },
      { id: "luxury", label: "Luxe", description: "Intelligence de niveau entreprise. Profondeur maximale, analyse narrative, registre des risques et gains rapides." },
    ],
    examples: [
      "Häagen-Dazs, Regent Street Londres, https://www.haagen-dazs.co.uk/, Augmenter les ventes de 20% durant les mois d'hiver.",
      "Atelier de motos, Medellín Colombie Laureles, Ajouter des services de location et tuning sur mesure, Budget 2 000 USD.",
      "Mercado Libre, https://www.mercadolibre.com/",
      "Hôtel Boutique, Carthagène Colombie, Développer les réservations de voyageurs internationaux, Lancer un programme de fidélité.",
      "Tesla, https://www.tesla.com/, Optimiser les opérations des centres de service, Réduire les délais d'attente de 30%.",
      "Pharmacie Indépendante, Miami Floride, Concurrencer les grandes chaînes, Lancer la livraison et la télémédecine.",
      "Salle CrossFit, Brooklyn New York, Développer la base de membres, Lancer un programme d'entraînement en ligne.",
      "Cabinet de Droit de la Famille, Mexico, Attirer des clients à haute valeur, Stratégie de présence digitale.",
    ],
    beyondProfit: "BEYOND PROFIT",
    beyondProfitSub: "Optionnel",
    beyondProfitDesc: "Sélectionnez les initiatives pertinentes pour cette entreprise. Les résultats apparaîtront dans un onglet dédié.",
    beyondProfitTab: "Beyond Profit",
    beyondProfitTabSub: "Perspectives Juridiques, Sociales et Réglementaires",
    complianceSectionGovernance: "GOUVERNANCE D'ENTREPRISE",
    complianceSectionRegulatory: "CONFORMITÉ RÉGLEMENTAIRE ET SECTORIELLE",
    complianceSectionEVR:        "VALEUR ESTIMÉE À RISQUE",
    complianceImplementation:    "IMPLÉMENTATION",
    compliancePerformance:       "PERFORMANCE",
    complianceCompliance:        "CONFORMITÉ",
    complianceAnnualRange:       "FOURCHETTE D'EXPOSITION ANNUELLE",
    compliancePerIncident:       "COÛT PAR INCIDENT",
    complianceRefs:              "ADDIS · BLIPS",
    complianceFabNote:           "Suggéré — confirmer avec des preuves en Tune",
    bpOptions: { CSR: "RSE", ESG: "ESG", DEI: "DEI", TBL: "TBL", Sustainability: "SUS" },
    bpDefinitions: {
      CSR: "RSE — Responsabilité Sociale des Entreprises",
      ESG: "ESG — Environnement, Social et Gouvernance",
      DEI: "DEI — Diversité, Équité et Inclusion",
      TBL: "TBL — Triple Bilan",
      Sustainability: "SUS — Durabilité",
    },
    useTokens: "UTILISER",
    tokensPer: "1 TOKEN PAR",
    insufficientTokens: "TOKENS INSUFFISANTS",
    required: "REQUIS",
    bpLabels: { legal: "JURIDIQUE", social: "SOCIAL", regulatory: "RÉGLEMENTAIRE", news: "ACTUALITÉS", suggestions: "SUGGESTIONS" },
    bp: { analyzing: "ANALYSE EN COURS", gatheringContext: "COLLECTE DU CONTEXTE JURIDIQUE ET RÉGLEMENTAIRE...", generatingInsights: "GÉNÉRATION DES INSIGHTS ET SUGGESTIONS...", errorMsg: "Impossible de générer les insights Beyond Profit." },
    pdfControlled: "CONTRÔLÉ",
    pdfUncontrolled: "NON CONTRÔLÉ",
    sectionInfo: {
      Apps: "Applications logicielles spécifiques utilisées quotidiennement — plateformes SaaS, apps mobiles/web, outils de productivité et applications sectorielles.",
      Data: "Bases de données, entrepôts de données, outils BI et plateformes de stockage — la technologie qui stocke et traite les données métier.",
      Dev: "Outils de développement, gestion de versions, pipelines CI/CD, APIs consommées et outils de déploiement — la stack technique qui construit et maintient les logiciels.",
      Infrastructure: "Serveurs, plateformes cloud, réseaux, appareils IoT, CDN et matériel — la fondation physique et virtuelle sur laquelle tout repose.",
      Systems: "Plateformes d'entreprise qui orchestrent les opérations — ERP, CRM, WMS, MES et systèmes SIEM.",
      BizOps: "Opérations quotidiennes, processus administratifs, gestion financière et gouvernance organisationnelle.",
      Logistics: "Chaîne d'approvisionnement, transport, réseaux de livraison, distribution et fulfillment.",
      Inventory: "Gestion des stocks, opérations d'entrepôt, suivi des produits et processus d'approvisionnement.",
      Production: "Fabrication, prestation de services, contrôle qualité et processus de création du produit ou service.",
      Sales: "Génération de revenus, acquisition clients, stratégie tarifaire, campagnes marketing et gestion de la relation client.",
    },
    errorEmailNotConfirmed: "Veuillez confirmer votre adresse email avant de générer. Vérifiez votre boîte de réception.",
    errorConnectionTimeout: "La connexion a pris plus de 60 secondes. Veuillez réessayer.",
    errorInsufficientBalance: "Solde de tokens insuffisant.",
    errorAccountNotFound: "Compte introuvable.",
    errorSaveChassis: "Impossible d'enregistrer votre Chassis. Aucun token n'a été débité.",
    auth: {
      signInTitle:    "Connexion à CHASS1S",
      signUpTitle:    "Créer Votre Compte",
      resetTitle:     "Réinitialiser Votre Mot de Passe",
      signInTab:      "CONNEXION",
      signUpTab:      "CRÉER UN COMPTE",
      forgotTab:      "RÉINITIALISER",
      emailLabel:     "ADRESSE EMAIL",
      passwordLabel:  "MOT DE PASSE",
      redirecting:    "REDIRECTION...",
      processing:     "TRAITEMENT...",
      sending:        "ENVOI...",
      sendReset:      "ENVOYER L'EMAIL DE RÉINITIALISATION",
      backToSignIn:   "Retour à la Connexion",
      forgotLink:     "Mot de passe oublié ?",
      signUpSuccess:  "Compte créé ! Vérifiez votre email pour confirmer.",
      resetSuccess:   "Email de réinitialisation envoyé. Vérifiez votre boîte.",
      freeTokens:     "Les nouveaux comptes reçoivent 10 TOKENS GRATUITS — sans carte bancaire.",
      orContinueWith: "OU CONTINUER AVEC",
    },
    // ── Account Menu ──
    menuSignedInAs: "CONNECTÉ EN TANT QUE",
    menuWorkspace: "ESPACE DE TRAVAIL",
    menuPersonal: "Personnel",
    menuAddWorkspace: "+ Espace de Travail",
    menuChassis: "CHASSIS",
    menuTokenBalance: "SOLDE DE TOKENS",
    menuBuyMore: "+ Acheter Plus",
    menuLanguage: "LANGUE",
    menuSignOut: "SE DÉCONNECTER",
    // ── Workspace configuration & deletion ──
    workspaceConfigEyebrow: "ESPACE · CONFIGURATION",
    workspaceConfigure: "Configurer l'espace",
    workspaceAddMember: "AJOUTER UN MEMBRE",
    workspaceDelete: "Supprimer l'espace",
    workspaceDeleteTitle: "⚠ SUPPRIMER L'ESPACE",
    workspaceDeleteBody: "Vous êtes sur le point de supprimer définitivement {name}. Cette action est irréversible.",
    workspaceDeleteImpact: "CELA AFFECTERA :",
    workspaceDeleteChassis: "{n} chassis seront définitivement supprimés",
    workspaceDeleteMembers: "{n} membres perdront l'accès",
    workspaceDeleteAck: "Je comprends que cet espace et tous ses chassis seront définitivement supprimés.",
    workspaceDeleteConfirm: "SUPPRIMER DÉFINITIVEMENT",
    workspaceDeleteCancel: "ANNULER",
    chassisDeleteNotOwner: "Seule la personne qui a créé ce Chassis peut le supprimer.",
    workspaceInviteNoAccount: "Aucun compte CHASS1S ne correspond à cet e-mail. Demandez-lui de s'inscrire d'abord.",
    workspaceInviteAlreadyMember: "Cette personne est déjà membre de cet espace.",
    workspaceInviteAdded: "{email} ajouté en tant que {role}.",
    workspaceRoleMember: "Membre",
    workspaceRoleCoOwner: "Co-Propriétaire",
    workspaceInviteMailFailed: "Membre ajouté, mais l'e-mail de notification n'a pas pu être envoyé.",
    // ── Settings & Support ──
    menuSettings: "Paramètres",
    menuSupport: "Support",
    settingsTitle: "Paramètres du Compte",
    settingsSectionProfile: "INFORMATIONS DE PROFIL",
    settingsSave: "ENREGISTRER",
    settingsSaving: "ENREGISTREMENT...",
    settingsSaved: "✓ Enregistré",
    settingsSectionSecurity: "SÉCURITÉ",
    settingsNewEmail: "NOUVEL EMAIL",
    settingsUpdateEmail: "METTRE À JOUR L'EMAIL",
    settingsCurrentPassword: "MOT DE PASSE ACTUEL",
    settingsNewPassword: "NOUVEAU MOT DE PASSE",
    settingsConfirmPassword: "CONFIRMER LE MOT DE PASSE",
    settingsUpdatePassword: "METTRE À JOUR LE MOT DE PASSE",
    settingsOAuthNoPassword: "La connexion par mot de passe n'est pas disponible pour votre compte. Vous vous êtes connecté via un fournisseur social.",
    settingsSectionConnected: "COMPTES CONNECTÉS",
    settingsSectionDanger: "FERMER LE COMPTE",
    settingsDangerWarning: "Votre compte sera programmé pour suppression dans 30 jours. Vous pouvez le réactiver en vous connectant avant cette date.",
    settingsDangerPrompt: "Tapez DELETE pour confirmer",
    settingsDeactivateBtn: "DÉSACTIVER LE COMPTE",
    settingsDeactivated: "Compte désactivé. Vous allez être déconnecté.",
    settingsDangerShow: "Afficher les options",
    settingsDisplayName: "NOM",
    settingsCountry: "PAYS",
    settingsSelectPlaceholder: "— Sélectionner —",
    settingsAgeRange: "TRANCHE D'ÂGE",
    settingsRoles: "VOS RÔLE(S)",
    settingsEmailPasswordHint: "Saisissez votre mot de passe actuel pour commencer.",
    settingsCurrentPwdPh: "Mot de passe actuel",
    settingsShow: "afficher",
    settingsHide: "masquer",
    settingsVerifyPassword: "VÉRIFIER MOT DE PASSE",
    settingsOtpHint: "Un code a été envoyé à {email}. Saisissez-le.",
    settingsOtpPlaceholder: "Code à 6 chiffres",
    settingsVerifyCode: "VÉRIFIER CODE",
    settingsCancel: "Annuler",
    settingsIdentityVerified: "Identité vérifiée. Saisissez votre nouvel e-mail.",
    settingsNewEmailPlaceholder: "Nouvelle adresse e-mail",
    settingsSendConfirmation: "ENVOYER LA CONFIRMATION",
    settingsConfirmationSent: "Confirmation envoyée à {email}. Vérifiez votre boîte mail.",
    settingsDone: "TERMINÉ",
    settingsLinkingNote: "Liaison / dissociation non disponible dans cette version.",
    settingsChangePassword: "CHANGER LE MOT DE PASSE",
    settingsPwdUpdated: "Mis à jour",
    settingsErrIncorrectPwd: "Mot de passe incorrect. Veuillez réessayer.",
    settingsErrNetwork: "Erreur réseau. Veuillez réessayer.",
    settingsErrPwdMatch: "Les mots de passe ne correspondent pas",
    settingsErrPwdLength: "Minimum 6 caractères",
    settingsErrCurrentPwd: "Le mot de passe actuel est incorrect",
    settingsErrInvalidCode: "Code invalide ou expiré.",
    supportTitle: "Contacter le Support",
    supportCategoryLabel: "CATÉGORIE DU PROBLÈME",
    supportCategories: ["Facturation & Tokens", "Problème Technique", "Accès au Compte", "Qualité de Génération", "Demande de Fonctionnalité", "Autre"],
    supportCategoryPlaceholder: "— Sélectionner une catégorie —",
    supportDescriptionLabel: "DESCRIPTION",
    supportDescriptionPlaceholder: "Décrivez votre problème en détail (minimum 20 caractères)...",
    supportAttachLabel: "PIÈCE JOINTE (optionnel)",
    supportChooseFile: "CHOISIR FICHIER",
    supportFileSizeError: "Le fichier doit faire moins de 5 Mo",
    supportFileTypeError: "Seules les images et les fichiers PDF sont acceptés",
    supportSubmit: "SOUMETTRE LE TICKET",
    supportSubmitting: "ENVOI EN COURS...",
    supportSuccessTitle: "Ticket Soumis",
    supportSuccessMsg: "Nous vous répondrons dans 24–48 heures. Votre numéro de ticket est :",
    supportAttachFailed: "Votre ticket a été envoyé, mais le fichier n'a pas pu être joint. Répondez à l'e-mail de confirmation pour l'envoyer.",
    supportClose: "FERMER",
    tokenBreadcrumb: "CHASS1S - ACHAT DE TOKENS",
    tokenTitle: "Acheter des Tokens",
    tokenBalance: "Solde actuel :",
    tokenBalanceSuffix: "tokens",
    tokenDepositLabel: "MONTANT DU DÉPÔT (USD)",
    tokenMinMax: "Minimum 25,00 $ - Maximum 1 000,00 $",
    tokenBreakdownLabel: "DÉTAIL DES TOKENS",
    tokenBaseTokens: "Tokens de base ($1 = 1 token)",
    tokenVolumeBonus: "Bonus volume",
    tokenTotal: "TOTAL TOKENS",
    tokenPromoLabel: "CODE PROMO (OPTIONNEL)",
    tokenPromoPlaceholder: "Entrez le code",
    tokenApply: "APPLIQUER",
    tokenPromoError: "Code promo invalide.",
    tokenPromoNetworkErr: "Impossible de valider le code.",
    tokenProceedBtn: "PROCÉDER À STRIPE",
    tokenCostLabel: "RÉFÉRENCE DES COÛTS CHASS1S",
    tokenFooter: "Paiements traités en toute sécurité par Stripe - Les tokens n'expirent jamais - Non remboursable",
    historyBreadcrumb: "CHASS1S - HISTORIQUE",
    historyTitle: "Mes Chass1s",
    historyCount: "{n} Chass1s générés",
    historyLoading: "CHARGEMENT...",
    historyEmpty: "PAS ENCORE DE CHASS1S",
    historyEmptyDesc: "Générez votre premier Chass1s et il apparaîtra ici.",
    historyUnnamed: "Chass1s sans nom",
    historyOpen: "OUVRIR",
    workspaceCreateTitle: "Créer un Espace de Travail",
    workspaceCreateDesc: "Collaborez avec votre équipe et partagez un pool de tokens. Vous serez le Propriétaire.",
    workspaceNameLabel: "NOM DE L'ESPACE",
    workspaceNamePh: "ex. Acme Corp, Équipe Marketing...",
    workspaceCreating: "CRÉATION EN COURS...",
    workspaceCreateBtn: "CRÉER L'ESPACE",
    workspaceCreateFooter: "Les copropriétaires et membres peuvent être invités depuis les paramètres de l'espace après création.",
    workspaceCreateError: "Impossible de créer l'espace",
    modeSelector: {
      fabricate: "Fabricate",
      tune: "Tune",
      drive: "Drive",
      go: "GO",
      comingSoon: "Bientôt",
    },
    tune: {
      lessonsColumn: "LEÇONS",
      payModalTitle: "ACTIVER LE MODE TUNE",
      payModalBody: "L'activation du mode Tune vous permet de modifier chaque élément de ce Chassis. Une fois payé, basculez librement jusqu'à Refabriquer.",
      payConfirm: "UTILISER {n} TOKENS ET ACTIVER TUNE",
      balance: "SOLDE",
      modeOn: "TUNE: ACTIVÉ",
      clickToExit: "CLIQUER POUR QUITTER",
      activeIndicatorTooltip: "Mode Tune actif",
      editHistoryTitle: "HISTORIQUE DES MODIFICATIONS",
      loadingHistory: "CHARGEMENT DE L'HISTORIQUE...",
      noEditHistory: "Pas d'historique pour cet élément.",
      revertButton: "REVENIR À CETTE VERSION",
      pctOnRefabricate: "POURCENTAGES RECALCULÉS À LA REFABRICATION",
      downgradeTitleWarning: "⚠ RÉDUCTION DE NIVEAU — PROFONDEUR RÉDUITE",
      downgradeBody: "Réduire le niveau diminuera le nombre d'éléments ADDIS, BLIPS, KBRs et les détails de Conformité dans votre Chassis refabriqué. Les modifications Tune confirmées seront toujours respectées comme vérité de base, mais le budget de tokens réduit signifie que certaines zones seront condensées. Vous pouvez revenir à un niveau supérieur à tout moment.",
      addElement: "AJOUTER UN ÉLÉMENT",
      teach: "ENSEIGNER",
      addElementTitle: "AJOUTER UN ÉLÉMENT",
      addElementManual: "SAISIE MANUELLE",
      addElementAssisted: "ASSISTÉ",
      addElementConsultant: "VUE CONSULTANT",
      addElementNameLabel: "NOM DE L'ÉLÉMENT",
      addElementTypeLabel: "TYPE",
      addElementDataLabel: "DONNÉES",
      addElementTitleLabel: "TITRE",
      addElementDescLabel: "DESCRIPTION",
      addElementMetricLabel: "MÉTRIQUE",
      addElementTargetLabel: "OBJECTIF",
      addElementInExLabel: "INT / EXT",
      addElementEnvLabel: "ENVIRONNEMENT",
      addElementSourceLabel: "SOURCE",
      addElementSave: "ENREGISTRER L'ÉLÉMENT",
      addElementAssistedPrompt: "Décrivez ce que vous souhaitez ajouter et l'IA suggérera des éléments correspondants.",
      addElementGenerate: "GÉNÉRER DES SUGGESTIONS",
      addElementConsultantPrompt: "Décrivez le contexte commercial et l'IA proposera des éléments d'un point de vue consultant.",
      teachTitle: "ENSEIGNER",
      saveContentError: "Impossible d'enregistrer ce contenu.",
      addContentInput: "TEXTE",
      addContentAttach: "JOINDRE",
      addContentCapture: "CAPTURER",
      addContentLink: "LIEN",
      addContentConnect: "CONNECTER",
      teachTooltip: "Enseignez à CHASS1S les éléments sélectionnés",
      lessons: "LEÇONS",
      lessonTitleLabel: "TITRE DE LA LEÇON",
      lessonTitlePlaceholder: "Nommez cette leçon",
      lessonSave: "ENREGISTRER LA LEÇON",
      lessonContemplating: "EN RÉFLEXION…",
      lessonUntitled: "Leçon sans titre",
      lessonMore: "+{n} de plus",
      lessonAckFailed: "Je n'ai pas pu répondre pour le moment. Nommez la leçon et enregistrez-la — rien n'est perdu.",
      lessonPendingAck: "J'ai reçu {files}. Je ne peux pas encore en lire le contenu — cette leçon sera enregistrée maintenant et j'y reviendrai.",
      lessonFileUnavailable: "fichier indisponible",
      lessonFileExpired: "Ce lien a expiré. Rouvrez la leçon pour en générer un nouveau.",
      classifyNext: "SUIVANT",
      addKbr: "AJOUTER UN KBR",
      kbrRemoveSection: "Retirer la section",
      lessonTranscribing: "Transcription…",
      lessonExtractFailed: "Lecture impossible",
      lessonUnsupportedFile: "Ce type de fichier ne peut pas encore être lu.",
      captureTooLarge: "Cet enregistrement est trop volumineux. Enregistrez un clip plus court.",
      addKbrSectionLabel: "SECTION",
      kbrSectionsCount: "{active} sur {limit} sections actives",
      kbrSectionsAtLimit: "Limite de sections du niveau atteinte",
      complianceAdd: "AJOUTER UN ÉLÉMENT",
      complianceAddTitle: "AJOUTER UN ÉLÉMENT DE CONFORMITÉ",
      complianceIdentifierLabel: "NORME / CATÉGORIE",
      addContentTextLabel: "VOS NOTES",
      addContentTextPlaceholder: "Saisissez du texte, des notes ou des observations…",
      addContentFileLabel: "JOINDRE UN FICHIER",
      addContentFileDrop: "Déposez un fichier ici ou cliquez pour parcourir",
      addContentLinkUrlLabel: "URL",
      addContentLinkTitleLabel: "TITRE (OPTIONNEL)",
      addContentCaptureStart: "DÉMARRER L'ENREGISTREMENT",
      addContentCaptureStop: "ARRÊTER L'ENREGISTREMENT",
      addContentCaptureAudio: "AUDIO",
      addContentCaptureVideo: "VIDÉO",
      addContentCapturePhoto: "PHOTOGRAPHIE",
      addContentCaptureChoose: "Choisissez ce qu'il faut capturer",
      addContentCaptureRetake: "REPRENDRE",
      addContentCaptureUse: "UTILISER CECI",
      addContentCaptureTimeLeft: "TEMPS RESTANT",
      addContentCaptureMicError: "Impossible d'accéder au microphone",
      addContentCaptureCameraError: "Impossible d'accéder à la caméra",
      classifyTitle: "CLASSIFIER LE CONTENU",
      classifyRoleLabel: "RÔLE DU CONTENU",
      classifyActionLabel: "ACTION IA",
      classifyRoleEvidence: "Preuve",
      classifyRoleExample: "Exemple",
      classifyRoleExplanation: "Explication",
      classifyActionComprehend: "Comprendre",
      classifyActionAnalyze: "Analyser",
      classifyActionQuery: "Interroger",
      classifyActionInstruction: "Instruction",
      classifySave: "ENREGISTRER",
      analyzePrompt: "Que souhaitez-vous que j'analyse ?",
      queryPrompt: "Entrez votre requête",
      instructionPrompt: "Que souhaitez-vous que je fasse avec ce contenu ?",
      eliminateConfirmTitle: "ÉLIMINER L'ÉLÉMENT",
      eliminateConfirmTitleMultiple: "ÉLIMINER {n} ÉLÉMENTS",
      eliminateConfirmBody: "Cet élément sera définitivement supprimé de cette section. Cette action est irréversible.",
      eliminateCheckLabel: "Je comprends que ces éléments seront supprimés du Chassis.",
      eliminateConfirmBodyMultiple: "{n} éléments seront définitivement supprimés de cette section. Cette action est irréversible.",
      addContentFileDropMultiple: "Déposez les fichiers ici ou cliquez pour parcourir — jusqu'à {n}",
      addContentFileMaxReached: "Maximum de {n} fichiers atteint",
      addContentLinkAdd: "AJOUTER UN LIEN",
      next: "SUIVANT",
      back: "RETOUR",
      eliminateConfirm: "ÉLIMINER",
      eliminateCancel: "ANNULER",
      connectTitle: "CONNECTER UNE APPLICATION",
      connectNative: "CONNECTER",
      connectPartial: "CONFIGURER",
      connectFallback: "CONFIGURATION GUIDÉE PAR IA",
      connectIdentify: "IDENTIFIER LE SERVICE",
      connectModalTitle: "CONNECTER",
      connectPrompt: "À quelle application, service ou système souhaitez-vous vous connecter ?",
      connectNativeSupported: "SUPPORT NATIF DÉTECTÉ",
      connectNativeBody: "Cliquez ci-dessous pour autoriser via un popup OAuth sécurisé. Une fois autorisé, vous pourrez sélectionner le fichier ou la source de données.",
      connectNativeAuth: "AUTORISER ET SÉLECTIONNER UN FICHIER",
      connectSave: "ENREGISTRER ET CONNECTER",
      connectFallbackBody: "Je n'ai pas de support natif pour \"{service}\". Voici vos options :",
      connectOptionApi: "API DIRECTE",
      connectOptionApiDesc: "Fournissez votre endpoint et clé API. Je l'interrogerai directement.",
      connectOptionJson: "EXPORT JSON",
      connectOptionJsonDesc: "Exportez vos données en JSON et téléchargez-les. Je les traiterai comme un instantané connecté.",
      connectOptionCustom: "SCRIPT PERSONNALISÉ",
      connectOptionCustomDesc: "Fournissez un script connecteur. Je l'exécuterai pour récupérer les données.",
      assistedSuggesting: "Suggestion en cours…",
      assistedFailed: "Aucune suggestion cette fois — remplissez les champs vous-même.",
      assistedAccept: "UTILISER ↵",
      consultantAnalyzing: "ANALYSE DE VOTRE CHASSIS…",
      consultantPickOne: "SÉLECTIONNEZ UN ÉLÉMENT À AJOUTER :",
      consultantRegenerate: "RÉGÉNÉRER",
      consultantError: "Impossible de générer des suggestions. Vérifiez votre connexion et réessayez.",
      consultantRetry: "RÉESSAYER",
    },
    reFabricate: {
      title: "Re-Fabricate Chassis",
      contextNote: "Votre Chass1s actuel sera utilisé pour produire un résultat encore plus riche.",
      originalInput: "SAISIE ORIGINALE",
      editHint: "Modifiez ou complétez votre saisie avant de re-fabriquer.",
      selectType: "SÉLECTIONNER TYPE",
      confirm: "RE-FABRICATE",
    },
    chassisHistory: {
      title: "Historique du Chass1s",
      actionFabricated: "Fabriqué",
      actionReFabricated: "Re-Fabriqué",
      actionTuned: "Réglé",
      chassisType: "TYPE DE CHASS1S",
      beyondProfit: "BEYOND PROFIT",
      none: "Aucun",
      noHistory: "Aucun historique.",
    },
    versions: {
      title: "Versions précédentes",
      subtitle: "Chaque re-fabrication remplace ce Chassis. La version remplacée est conservée ici.",
      current: "ACTUELLE",
      replacedOn: "Remplacée le",
      restore: "RESTAURER",
      restoring: "Restauration…",
      confirmTitle: "Restaurer cette version ?",
      confirmBody: "Cela remplace ce qui est affiché. Ce contenu est aussi conservé, vous pourrez y revenir. Aucun jeton n'est utilisé.",
      confirmYes: "RESTAURER",
      confirmNo: "ANNULER",
      none: "Aucune version précédente. Ce Chassis n'a pas été re-fabriqué.",
      failed: "Impossible de restaurer cette version.",
    },
    complianceLoadingStep: "CONSTRUCTION DU CADRE DE CONFORMITE...",
    kbrSummaryLabel: "OBJECTIFS",
    prgLabel: "PRG",
    prgModalTitle: "CROISSANCE DES REVENUS POSSIBLE",
    prgModalDef: "La Croissance des Revenus Possible (PRG) représente le potentiel si les KBR sont correctement appliqués. C'est un indicateur directionnel ancré dans le contexte du business — pas une garantie.",
    complianceCorp: "GOUVERNANCE D'ENTREPRISE",
    complianceCorpAbbrev: "CORP",
    complianceReg: "RÉGLEMENTAIRE",
    complianceRegAbbrev: "RÉG.",
    complianceEvr: "VALEUR À RISQUE",
    complianceEvrAbbrev: "EVR",
    complianceTabSub: "CORP · RÉG. · EVR",
    downloadLabel: "Télécharger",
    downloadLoading: "Génération du PDF…",
    downloadError: "Impossible de générer le PDF. Veuillez réessayer.",
    share: {
      label: "Partager",
      title: "PARTAGER LE CHASSIS",
      intro: "Toute personne disposant de ce lien peut lire ce Chassis au format JSON (ADDIS et BLIPS uniquement). La sortie originale de l'IA est partagée — les modifications de Tune et le Learning NE sont PAS inclus.",
      empty: "Aucun lien actif.",
      create: "CRÉER LE LIEN",
      regenerate: "RÉGÉNÉRER",
      revoke: "RÉVOQUER",
      copy: "COPIER",
      copied: "COPIÉ",
      expiry: "EXPIRE",
      newExpiry: "NOUVELLE EXPIRATION",
      expiryNever: "Jamais",
      expiryInDays: "Dans {d} jours",
      expired: "EXPIRÉ — régénérez pour partager à nouveau",
      close: "FERMER",
    },
    eliminate: { label: "Éliminer" },
  },
  PT: {
    tagline: "BUSINESS OBSERVABILITY FRAMEWORK",
    bossLink: "uma Boss.Technology",
    pageTitle: "Construa um Chass1s.",
    inputInstruction: "INSIRA UM TIPO DE NEGÓCIO ou NOME DE EMPRESA ATUAL, LOCALIZAÇÃO, SITE, OBJETIVOS, CONCEITOS OU QUALQUER COMBINAÇÃO — SEPARADOS POR VÍRGULAS.",
    deployHint: "⌘ + ENTER PARA IMPLANTAR · ABRE EM NOVA ABA",
    startBtn: "INICIAR FABRICAÇÃO",
    whatIsChs: "O QUE É CHASS1S?",
    chsDescription: "CHASS1S é o primeiro e único Business Observability (BO11Y) Framework do mundo — com o poder de Fabricar, Afinar e até Conduzir qualquer negócio novo ou existente, de uma sorveteria a uma companhia aérea. Pela primeira vez, tecnologia e negócio são unificados em um único veículo poderoso — onde cada decisão, cada mudança e cada insight reverbera com plena consciência do todo. Através de Business Observability, impulsionado por Applied AI, CHASS1S transforma a complexidade de gerir um negócio em algo observável, mensurável e acionável. O Framework moderno para Empresas Rápidas e Negócios em Tempo Real.",
    chsCreditBoss: { prefix: "CHASS1S é trazido a você pela ", name: "Boss.Technology", suffix: " — Premium Business Observability Builder, Tuner e Brand com base na América Latina." },
    chsCreditFederico: { prefix: "Criado por ", name: "Federico Lara", suffix: " — líder de pensamento em Business Observability, autor de Six Steps to Achieve Business Observability, criador de Metric Monetization, e ex-executivo na New Relic e Dynatrace." },
    selectDepth: "SELECIONAR PROFUNDIDADE DO CHASSIS",
    tabs: { intro: "INTRO", introSub: "Perfil do Negócio", addis: "ADDIS", addisSub: "Camada Tecnológica", blips: "BLIPS", blipsSub: "Camada de Negócio", kbrs: "KBRs", kbrsSub: "Key Business Results", compliance: "COMPLIANCE", complianceSub: "CORP · REG. · EVR" },
    expandAll: "EXPANDIR TUDO", collapseAll: "RECOLHER TUDO",
    sections: "SEÇÕES", items: "ITENS",
    businessProfile: "PERFIL DO NEGÓCIO", whyChassis: "CHASSIS", keyValuePoints: "PONTOS-CHAVE DE VALOR", frameworkApplied: "CHASSIS APLICADO",
    addisDesc: "Mapeia cada ferramenta tecnológica, plataforma, sistema e componente de infraestrutura dos quais este negócio depende.",
    blipsDesc: "Mapeia cada função de negócio e as fontes de dados observáveis que conectam o desempenho tecnológico aos resultados de negócio.",
    kbrTitle: "Key Business Results", kbrsAcross: "KBRs ACROSS", businessAreas: "BUSINESS AREAS",
    metric: "MÉTRICA", target: "META",
    newChassis: "NOVO CHASSIS",
    loadingTitle: "PROCESSANDO",
    loadingSteps: ["ANALISANDO TIPO DE NEGÓCIO...", "MAPEANDO CAMADA TECNOLÓGICA ADDIS...", "CONSTRUINDO CHASSIS DE NEGÓCIO BLIPS...", "GERANDO RESULTADOS-CHAVE DE NEGÓCIO...", "FABRICANDO CHASSIS..."],
    fabricatingPrefix: "FABRICANDO",
    charmingPhrases: [
      "Isso vai rápido — prepare-se.",
      "Ainda aqui? Ótimo. Nós também. Está indo bem.",
      "Alongue um pouco. Estaremos prontos quando você estiver.",
      "Isso está levando um momento. Um bom momento — como o de um bom espresso.",
      "Enquanto espera, vá abraçar um pet... não precisa ser o seu.",
      "Pode levar alguns minutos — peça aquela bebida complicada que você tanto ama.",
      "Estamos construindo algo personalizado, específico, seu. Boas coisas levam tempo.",
      "Continuando. Este é nosso trabalho mais completo. Vá buscar um lanche. Você merece.",
    ],
    errorTitle: "Algo deu errado.", tryAgain: "TENTAR NOVAMENTE",
    errorBpNotSaved: "Beyond Profit foi gerado, mas não pôde ser salvo. Copie o que precisar antes de recarregar.",
    tableHeaders: ["Item", "Tipo", "Descrição", "Int/Ext", "Ambiente", "Dados"],
    tableHeadersBlips: ["Item", "Fonte", "Tipo", "Descrição", "Int/Ext", "Ambiente", "Dados"],
    noItems: "Nenhum item gerado.",
    tiers: [
      { id: "compact", label: "Compacto", description: "Visão essencial. Itens principais de ADDIS e BLIPS com KBRs focados. Ideal para avaliações rápidas." },
      { id: "midsize", label: "Médio", description: "Profundidade aprimorada com contexto mais rico. Mais itens, descrições completas e fatores do mundo real ampliados." },
      { id: "executive", label: "Executivo", description: "Análise abrangente com contexto detalhado, cobertura do mundo real e KBRs enriquecidos com benchmarks setoriais." },
      { id: "luxury", label: "Luxo", description: "Inteligência de nível empresarial. Profundidade máxima, análise narrativa de impacto, registro de riscos e vitórias rápidas." },
    ],
    examples: [
      "Häagen-Dazs, Regent Street Londres, https://www.haagen-dazs.co.uk/, Aumentar vendas 20% nos meses de inverno.",
      "Oficina de Motos, Medellín Colômbia Laureles, Adicionar serviços de aluguel e tuning personalizado, Orçamento $2.000 USD.",
      "Mercado Livre, https://www.mercadolivre.com.br/",
      "Hotel Boutique, Cartagena Colômbia, Expandir reservas de viajantes internacionais, Lançar programa de fidelidade.",
      "Tesla, https://www.tesla.com/, Otimizar operações dos centros de serviço, Reduzir tempos de espera em 30%.",
      "Farmácia Independente, Miami Flórida, Competir com grandes redes, Implementar delivery e telemedicina.",
      "Academia CrossFit, Brooklyn Nova York, Expandir base de alunos, Lançar programa de treino online.",
      "Escritório de Direito de Família, Cidade do México, Atrair clientes premium, Estratégia de presença digital.",
    ],
    beyondProfit: "BEYOND PROFIT",
    beyondProfitSub: "Opcional",
    beyondProfitDesc: "Selecione as iniciativas relevantes para este negócio. Os resultados aparecerão em uma aba dedicada.",
    beyondProfitTab: "Beyond Profit",
    beyondProfitTabSub: "Insights Jurídicos, Sociais e Regulatórios",
    complianceSectionGovernance: "GOVERNANÇA CORPORATIVA",
    complianceSectionRegulatory: "CONFORMIDADE REGULATÓRIA E SETORIAL",
    complianceSectionEVR:        "VALOR ESTIMADO EM RISCO",
    complianceImplementation:    "IMPLEMENTAÇÃO",
    compliancePerformance:       "DESEMPENHO",
    complianceCompliance:        "CONFORMIDADE",
    complianceAnnualRange:       "FAIXA DE EXPOSIÇÃO ANUAL",
    compliancePerIncident:       "CUSTO POR INCIDENTE",
    complianceRefs:              "ADDIS · BLIPS",
    complianceFabNote:           "Sugerido — confirmar com evidências no Tune",
    bpOptions: { CSR: "RSC", ESG: "ESG", DEI: "DEI", TBL: "TBL", Sustainability: "SUS" },
    bpDefinitions: {
      CSR: "RSC — Responsabilidade Social Corporativa",
      ESG: "ESG — Ambiental, Social e Governança",
      DEI: "DEI — Diversidade, Equidade e Inclusão",
      TBL: "TBL — Triplo Resultado",
      Sustainability: "SUS — Sustentabilidade",
    },
    useTokens: "USAR",
    tokensPer: "1 TOKEN POR",
    insufficientTokens: "TOKENS INSUFICIENTES",
    required: "NECESSÁRIOS",
    bpLabels: { legal: "JURÍDICO", social: "SOCIAL", regulatory: "REGULATÓRIO", news: "NOTÍCIAS E DESENVOLVIMENTOS", suggestions: "SUGESTÕES" },
    bp: { analyzing: "ANALISANDO", gatheringContext: "COLETANDO CONTEXTO JURÍDICO E REGULATÓRIO...", generatingInsights: "GERANDO INSIGHTS E SUGESTÕES...", errorMsg: "Não foi possível gerar os insights Beyond Profit." },
    pdfControlled: "CONTROLADO",
    pdfUncontrolled: "NÃO CONTROLADO",
    sectionInfo: {
      Apps: "Aplicativos de software específicos usados diariamente — plataformas SaaS, apps móveis/web, ferramentas de produtividade e aplicativos setoriais.",
      Data: "Bancos de dados, data warehouses, ferramentas de BI e plataformas de armazenamento — a tecnologia que armazena e processa os dados do negócio.",
      Dev: "Ferramentas de desenvolvimento, controle de versão, pipelines CI/CD, APIs consumidas e ferramentas de deploy — a stack tecnológica que constrói e mantém o software.",
      Infrastructure: "Servidores, plataformas cloud, redes, dispositivos IoT, CDNs e hardware — a base física e virtual sobre a qual tudo opera.",
      Systems: "Plataformas empresariais que orquestram operações — ERP, CRM, WMS, MES e sistemas SIEM.",
      BizOps: "Operações diárias do negócio, processos administrativos, gestão financeira e governança organizacional.",
      Logistics: "Cadeia de suprimentos, transporte, redes de entrega, distribuição e operações de fulfillment.",
      Inventory: "Gestão de estoque, operações de armazém, rastreamento de produtos e processos de compras.",
      Production: "Fabricação, entrega de serviços, controle de qualidade e processos que criam o produto ou serviço.",
      Sales: "Geração de receita, aquisição de clientes, estratégia de preços, campanhas de marketing e gestão do relacionamento com clientes.",
    },
    errorEmailNotConfirmed: "Por favor confirme seu endereço de email antes de gerar. Verifique sua caixa de entrada.",
    errorConnectionTimeout: "A conexão demorou mais de 60 segundos para ser estabelecida. Tente novamente.",
    errorInsufficientBalance: "Saldo de tokens insuficiente.",
    errorAccountNotFound: "Conta não encontrada.",
    errorSaveChassis: "Não foi possível salvar seu Chassis. Nenhum token foi cobrado.",
    auth: {
      signInTitle:    "Entrar no CHASS1S",
      signUpTitle:    "Criar Sua Conta",
      resetTitle:     "Redefinir Sua Senha",
      signInTab:      "ENTRAR",
      signUpTab:      "CRIAR CONTA",
      forgotTab:      "REDEFINIR",
      emailLabel:     "ENDEREÇO DE EMAIL",
      passwordLabel:  "SENHA",
      redirecting:    "REDIRECIONANDO...",
      processing:     "PROCESSANDO...",
      sending:        "ENVIANDO...",
      sendReset:      "ENVIAR EMAIL DE REDEFINIÇÃO",
      backToSignIn:   "Voltar ao Login",
      forgotLink:     "Esqueceu a senha?",
      signUpSuccess:  "Conta criada! Verifique seu email para confirmar.",
      resetSuccess:   "Email de redefinição enviado. Verifique sua caixa.",
      freeTokens:     "Novas contas recebem 10 TOKENS GRATUITOS — sem cartão de crédito.",
      orContinueWith: "OU CONTINUAR COM",
    },
    // ── Account Menu ──
    menuSignedInAs: "CONECTADO COMO",
    menuWorkspace: "ESPAÇO DE TRABALHO",
    menuPersonal: "Pessoal",
    menuAddWorkspace: "+ Espaço de Trabalho",
    menuChassis: "CHASSIS",
    menuTokenBalance: "SALDO DE TOKENS",
    menuBuyMore: "+ Comprar Mais",
    menuLanguage: "IDIOMA",
    menuSignOut: "SAIR",
    // ── Workspace configuration & deletion ──
    workspaceConfigEyebrow: "ESPAÇO · CONFIGURAÇÃO",
    workspaceConfigure: "Configurar espaço",
    workspaceAddMember: "ADICIONAR MEMBRO",
    workspaceDelete: "Excluir espaço",
    workspaceDeleteTitle: "⚠ EXCLUIR ESPAÇO",
    workspaceDeleteBody: "Você está prestes a excluir permanentemente {name}. Esta ação não pode ser desfeita.",
    workspaceDeleteImpact: "ISTO AFETARÁ:",
    workspaceDeleteChassis: "{n} chassis serão excluídos permanentemente",
    workspaceDeleteMembers: "{n} membros perderão o acesso",
    workspaceDeleteAck: "Entendo que este espaço e todos os seus chassis serão excluídos permanentemente.",
    workspaceDeleteConfirm: "EXCLUIR PERMANENTEMENTE",
    workspaceDeleteCancel: "CANCELAR",
    chassisDeleteNotOwner: "Apenas quem criou este Chassis pode excluí-lo.",
    workspaceInviteNoAccount: "Nenhuma conta CHASS1S encontrada com esse e-mail. Peça que se cadastre primeiro.",
    workspaceInviteAlreadyMember: "Essa pessoa já é membro deste espaço.",
    workspaceInviteAdded: "{email} adicionado como {role}.",
    workspaceRoleMember: "Membro",
    workspaceRoleCoOwner: "Coproprietário",
    workspaceInviteMailFailed: "Membro adicionado, mas não foi possível enviar o e-mail de notificação.",
    // ── Settings & Support ──
    menuSettings: "Configurações",
    menuSupport: "Suporte",
    settingsTitle: "Configurações da Conta",
    settingsSectionProfile: "INFORMAÇÕES DE PERFIL",
    settingsSave: "SALVAR ALTERAÇÕES",
    settingsSaving: "SALVANDO...",
    settingsSaved: "✓ Salvo",
    settingsSectionSecurity: "SEGURANÇA",
    settingsNewEmail: "NOVO EMAIL",
    settingsUpdateEmail: "ATUALIZAR EMAIL",
    settingsCurrentPassword: "SENHA ATUAL",
    settingsNewPassword: "NOVA SENHA",
    settingsConfirmPassword: "CONFIRMAR NOVA SENHA",
    settingsUpdatePassword: "ATUALIZAR SENHA",
    settingsOAuthNoPassword: "O login com senha não está disponível para sua conta. Você entrou com um provedor social.",
    settingsSectionConnected: "CONTAS CONECTADAS",
    settingsSectionDanger: "FECHAR CONTA",
    settingsDangerWarning: "Sua conta será agendada para exclusão em 30 dias. Você pode reativá-la fazendo login antes dessa data.",
    settingsDangerPrompt: "Digite DELETE para confirmar",
    settingsDeactivateBtn: "DESATIVAR CONTA",
    settingsDeactivated: "Conta desativada. Você será desconectado.",
    settingsDangerShow: "Mostrar opções",
    settingsDisplayName: "NOME",
    settingsCountry: "PAÍS",
    settingsSelectPlaceholder: "— Selecionar —",
    settingsAgeRange: "FAIXA ETÁRIA",
    settingsRoles: "SEU(S) PAPEL(IS)",
    settingsEmailPasswordHint: "Insira sua senha atual para começar.",
    settingsCurrentPwdPh: "Senha atual",
    settingsShow: "mostrar",
    settingsHide: "ocultar",
    settingsVerifyPassword: "VERIFICAR SENHA",
    settingsOtpHint: "Um código foi enviado para {email}. Insira-o abaixo.",
    settingsOtpPlaceholder: "Código de 6 dígitos",
    settingsVerifyCode: "VERIFICAR CÓDIGO",
    settingsCancel: "Cancelar",
    settingsIdentityVerified: "Identidade verificada. Insira seu novo e-mail.",
    settingsNewEmailPlaceholder: "Novo endereço de e-mail",
    settingsSendConfirmation: "ENVIAR CONFIRMAÇÃO",
    settingsConfirmationSent: "Confirmação enviada para {email}. Verifique sua caixa de entrada.",
    settingsDone: "FEITO",
    settingsLinkingNote: "Vincular / desvincular não disponível nesta versão.",
    settingsChangePassword: "ALTERAR SENHA",
    settingsPwdUpdated: "Atualizado",
    settingsErrIncorrectPwd: "Senha incorreta. Por favor, tente novamente.",
    settingsErrNetwork: "Erro de rede. Por favor, tente novamente.",
    settingsErrPwdMatch: "As senhas não coincidem",
    settingsErrPwdLength: "Mínimo 6 caracteres",
    settingsErrCurrentPwd: "A senha atual está incorreta",
    settingsErrInvalidCode: "Código inválido ou expirado.",
    supportTitle: "Contatar Suporte",
    supportCategoryLabel: "CATEGORIA DO PROBLEMA",
    supportCategories: ["Cobrança e Tokens", "Problema Técnico", "Acesso à Conta", "Qualidade de Geração", "Solicitação de Funcionalidade", "Outro"],
    supportCategoryPlaceholder: "— Selecionar categoria —",
    supportDescriptionLabel: "DESCRIÇÃO",
    supportDescriptionPlaceholder: "Descreva seu problema em detalhes (mínimo 20 caracteres)...",
    supportAttachLabel: "ANEXO (opcional)",
    supportChooseFile: "ESCOLHER ARQUIVO",
    supportFileSizeError: "O arquivo deve ter menos de 5MB",
    supportFileTypeError: "Apenas imagens e arquivos PDF são aceitos",
    supportSubmit: "ENVIAR TICKET",
    supportSubmitting: "ENVIANDO...",
    supportSuccessTitle: "Ticket Enviado",
    supportSuccessMsg: "Responderemos em 24–48 horas. Seu número de ticket é:",
    supportAttachFailed: "O seu pedido foi enviado, mas o ficheiro não pôde ser anexado. Responda ao e-mail de confirmação para o enviar.",
    supportClose: "FECHAR",
    tokenBreadcrumb: "CHASS1S - COMPRA DE TOKENS",
    tokenTitle: "Comprar Tokens",
    tokenBalance: "Saldo atual:",
    tokenBalanceSuffix: "tokens",
    tokenDepositLabel: "VALOR DO DEPÓSITO (USD)",
    tokenMinMax: "Mínimo $25,00 - Máximo $1.000,00",
    tokenBreakdownLabel: "DETALHAMENTO DE TOKENS",
    tokenBaseTokens: "Tokens base ($1 = 1 token)",
    tokenVolumeBonus: "Bonus por volume",
    tokenTotal: "TOTAL DE TOKENS",
    tokenPromoLabel: "CÓDIGO PROMOCIONAL (OPCIONAL)",
    tokenPromoPlaceholder: "Digite o código",
    tokenApply: "APLICAR",
    tokenPromoError: "Código promocional inválido.",
    tokenPromoNetworkErr: "Não foi possível validar o código.",
    tokenProceedBtn: "PROSSEGUIR PARA O STRIPE",
    tokenCostLabel: "REFERÊNCIA DE CUSTOS CHASS1S",
    tokenFooter: "Pagamentos processados com segurança pelo Stripe - Tokens não expiram - Não reembolsável",
    historyBreadcrumb: "CHASS1S - HISTÓRICO",
    historyTitle: "Meus Chass1s",
    historyCount: "{n} Chass1s gerados",
    historyLoading: "CARREGANDO...",
    historyEmpty: "SEM CHASS1S AINDA",
    historyEmptyDesc: "Gere seu primeiro Chass1s e ele aparecerá aqui.",
    historyUnnamed: "Chass1s sem nome",
    historyOpen: "ABRIR",
    workspaceCreateTitle: "Criar Espaço de Trabalho",
    workspaceCreateDesc: "Colabore com sua equipe e compartilhe um pool de tokens. Você será o Proprietário.",
    workspaceNameLabel: "NOME DO ESPAÇO",
    workspaceNamePh: "ex. Acme Corp, Equipe de Marketing...",
    workspaceCreating: "CRIANDO...",
    workspaceCreateBtn: "CRIAR ESPAÇO",
    workspaceCreateFooter: "Coproprietários e Membros podem ser convidados nas configurações do espaço após a criação.",
    workspaceCreateError: "Falha ao criar o espaço",
    modeSelector: {
      fabricate: "Fabricate",
      tune: "Tune",
      drive: "Drive",
      go: "IR",
      comingSoon: "Em Breve",
    },
    tune: {
      lessonsColumn: "LIÇÕES",
      payModalTitle: "ENTRAR MODO TUNE",
      payModalBody: "Entrar no modo Tune permite editar cada elemento deste Chassis. Uma vez pago, alterne livremente até Refabricar.",
      payConfirm: "USAR {n} TOKENS E ENTRAR NO TUNE",
      balance: "SALDO",
      modeOn: "TUNE: ATIVO",
      clickToExit: "CLIQUE PARA SAIR",
      activeIndicatorTooltip: "Modo Tune ativo",
      editHistoryTitle: "HISTÓRICO DE EDIÇÕES",
      loadingHistory: "A CARREGAR HISTÓRICO...",
      noEditHistory: "Sem histórico de edições para este elemento.",
      revertButton: "REVERTER PARA ESTA VERSÃO",
      pctOnRefabricate: "PERCENTAGENS RECALCULADAS NA REFABRICAÇÃO",
      downgradeTitleWarning: "⚠ REDUÇÃO DE NÍVEL — MENOR PROFUNDIDADE",
      downgradeBody: "Reduzir o nível diminuirá o número de elementos ADDIS, BLIPS, KBRs e o detalhe de Conformidade no seu Chassis refabricado. As edições de Tune confirmadas ainda serão respeitadas como verdade base, mas o menor orçamento de tokens significa que algumas áreas serão condensadas. Pode voltar a subir de nível refabricando num nível superior.",
      addElement: "ADICIONAR ELEMENTO",
      teach: "ENSINAR",
      addElementTitle: "ADICIONAR ELEMENTO",
      addElementManual: "ENTRADA MANUAL",
      addElementAssisted: "ASSISTIDO",
      addElementConsultant: "VISÃO CONSULTOR",
      addElementNameLabel: "NOME DO ELEMENTO",
      addElementTypeLabel: "TIPO",
      addElementDataLabel: "DADOS",
      addElementTitleLabel: "TÍTULO",
      addElementDescLabel: "DESCRIÇÃO",
      addElementMetricLabel: "MÉTRICA",
      addElementTargetLabel: "META",
      addElementInExLabel: "INT / EXT",
      addElementEnvLabel: "AMBIENTE",
      addElementSourceLabel: "FONTE",
      addElementSave: "GUARDAR ELEMENTO",
      addElementAssistedPrompt: "Descreva o que quer adicionar e a IA sugerirá elementos correspondentes.",
      addElementGenerate: "GERAR SUGESTÕES",
      addElementConsultantPrompt: "Descreva o contexto do negócio e a IA proporá elementos numa perspetiva de consultor.",
      teachTitle: "ENSINAR",
      saveContentError: "Não foi possível salvar este conteúdo.",
      addContentInput: "TEXTO",
      addContentAttach: "ANEXAR",
      addContentCapture: "CAPTURAR",
      addContentLink: "LIGAÇÃO",
      addContentConnect: "LIGAR",
      teachTooltip: "Ensine o CHASS1S sobre os elementos selecionados",
      lessons: "LIÇÕES",
      lessonTitleLabel: "TÍTULO DA LIÇÃO",
      lessonTitlePlaceholder: "Nomeie esta lição",
      lessonSave: "SALVAR LIÇÃO",
      lessonContemplating: "CONTEMPLANDO…",
      lessonUntitled: "Lição sem título",
      lessonMore: "+{n} mais",
      lessonAckFailed: "Não consegui responder agora. Nomeie a lição e salve-a — nada se perde.",
      lessonPendingAck: "Recebi {files}. Ainda não consigo ler seu conteúdo — esta lição será salva agora e voltarei a ela.",
      lessonFileUnavailable: "arquivo indisponível",
      lessonFileExpired: "Este link expirou. Reabra a lição para gerar um novo.",
      classifyNext: "PRÓXIMO",
      addKbr: "ADICIONAR KBR",
      kbrRemoveSection: "Remover seção",
      lessonTranscribing: "Transcrevendo…",
      lessonExtractFailed: "Não foi possível ler",
      lessonUnsupportedFile: "Este tipo de arquivo ainda não pode ser lido.",
      captureTooLarge: "Essa gravação é muito grande. Grave um clipe mais curto.",
      addKbrSectionLabel: "SEÇÃO",
      kbrSectionsCount: "{active} de {limit} seções ativas",
      kbrSectionsAtLimit: "Limite de seções do nível atingido",
      complianceAdd: "ADICIONAR ITEM",
      complianceAddTitle: "ADICIONAR ITEM DE CONFORMIDADE",
      complianceIdentifierLabel: "NORMA / CATEGORIA",
      addContentTextLabel: "AS SUAS NOTAS",
      addContentTextPlaceholder: "Introduza texto, notas ou observações…",
      addContentFileLabel: "ANEXAR FICHEIRO",
      addContentFileDrop: "Largue um ficheiro aqui ou clique para procurar",
      addContentLinkUrlLabel: "URL",
      addContentLinkTitleLabel: "TÍTULO (OPCIONAL)",
      addContentCaptureStart: "INICIAR GRAVAÇÃO",
      addContentCaptureStop: "PARAR GRAVAÇÃO",
      addContentCaptureAudio: "ÁUDIO",
      addContentCaptureVideo: "VÍDEO",
      addContentCapturePhoto: "FOTOGRAFIA",
      addContentCaptureChoose: "Escolha o que capturar",
      addContentCaptureRetake: "REGRAVAR",
      addContentCaptureUse: "USAR ISTO",
      addContentCaptureTimeLeft: "TEMPO RESTANTE",
      addContentCaptureMicError: "Não foi possível acessar o microfone",
      addContentCaptureCameraError: "Não foi possível acessar a câmera",
      classifyTitle: "CLASSIFICAR CONTEÚDO",
      classifyRoleLabel: "FUNÇÃO DO CONTEÚDO",
      classifyActionLabel: "AÇÃO IA",
      classifyRoleEvidence: "Evidência",
      classifyRoleExample: "Exemplo",
      classifyRoleExplanation: "Explicação",
      classifyActionComprehend: "Compreender",
      classifyActionAnalyze: "Analisar",
      classifyActionQuery: "Consultar",
      classifyActionInstruction: "Instrução",
      classifySave: "GUARDAR",
      analyzePrompt: "O que você gostaria que eu analisasse?",
      queryPrompt: "Insira sua consulta",
      instructionPrompt: "O que você gostaria que eu fizesse com este conteúdo?",
      eliminateConfirmTitle: "ELIMINAR ELEMENTO",
      eliminateConfirmTitleMultiple: "ELIMINAR {n} ELEMENTOS",
      eliminateConfirmBody: "Este elemento será removido permanentemente desta secção. Esta ação não pode ser desfeita.",
      eliminateCheckLabel: "Entendo que estes elementos serão removidos do Chassis.",
      eliminateConfirmBodyMultiple: "{n} elementos serão removidos permanentemente desta secção. Esta ação não pode ser desfeita.",
      addContentFileDropMultiple: "Solte arquivos aqui ou clique para procurar — até {n}",
      addContentFileMaxReached: "Máximo de {n} arquivos atingido",
      addContentLinkAdd: "ADICIONAR LINK",
      next: "PRÓXIMO",
      back: "VOLTAR",
      eliminateConfirm: "ELIMINAR",
      eliminateCancel: "CANCELAR",
      connectTitle: "LIGAR APLICAÇÃO",
      connectNative: "LIGAR",
      connectPartial: "CONFIGURAR",
      connectFallback: "CONFIGURAÇÃO GUIADA POR IA",
      connectIdentify: "IDENTIFICAR SERVIÇO",
      connectModalTitle: "CONECTAR",
      connectPrompt: "A qual aplicação, serviço ou sistema você deseja se conectar?",
      connectNativeSupported: "SUPORTE NATIVO DETECTADO",
      connectNativeBody: "Clique abaixo para autorizar via popup OAuth seguro. Uma vez autorizado, você poderá selecionar o arquivo ou fonte de dados.",
      connectNativeAuth: "AUTORIZAR E SELECIONAR ARQUIVO",
      connectSave: "SALVAR E CONECTAR",
      connectFallbackBody: "Não tenho suporte nativo para \"{service}\". Aqui estão suas opções:",
      connectOptionApi: "API DIRETA",
      connectOptionApiDesc: "Forneça seu endpoint e chave de API. Vou consultá-la diretamente.",
      connectOptionJson: "EXPORTAÇÃO JSON",
      connectOptionJsonDesc: "Exporte seus dados como JSON e envie. Tratarei como um instantâneo conectado.",
      connectOptionCustom: "SCRIPT PERSONALIZADO",
      connectOptionCustomDesc: "Forneça um script conector. Vou executá-lo para recuperar os dados.",
      assistedSuggesting: "Sugerindo…",
      assistedFailed: "Sem sugestão desta vez — preencha os campos manualmente.",
      assistedAccept: "USAR ↵",
      consultantAnalyzing: "ANALISANDO SEU CHASSIS…",
      consultantPickOne: "SELECIONE UM ELEMENTO A ADICIONAR:",
      consultantRegenerate: "REGENERAR",
      consultantError: "Não foi possível gerar sugestões. Verifique sua conexão e tente novamente.",
      consultantRetry: "TENTAR NOVAMENTE",
    },
    reFabricate: {
      title: "Re-Fabricate Chassis",
      contextNote: "Seu Chass1s atual será usado para construir um resultado ainda mais rico.",
      originalInput: "ENTRADA ORIGINAL",
      editHint: "Edite ou expanda sua entrada antes de re-fabricar.",
      selectType: "SELECIONAR TIPO",
      confirm: "RE-FABRICATE",
    },
    chassisHistory: {
      title: "Histórico do Chass1s",
      actionFabricated: "Fabricado",
      actionReFabricated: "Re-Fabricado",
      actionTuned: "Afinado",
      chassisType: "TIPO DE CHASS1S",
      beyondProfit: "BEYOND PROFIT",
      none: "Nenhum",
      noHistory: "Sem histórico ainda.",
    },
    versions: {
      title: "Versões anteriores",
      subtitle: "Cada re-fabricação substitui este Chassis. A versão substituída fica guardada aqui.",
      current: "ATUAL",
      replacedOn: "Substituída em",
      restore: "RESTAURAR",
      restoring: "A restaurar…",
      confirmTitle: "Restaurar esta versão?",
      confirmBody: "Isto substitui o que está no ecrã. Esse conteúdo também fica guardado, pode voltar a ele. Não são gastos tokens.",
      confirmYes: "RESTAURAR",
      confirmNo: "CANCELAR",
      none: "Sem versões anteriores. Este Chassis não foi re-fabricado.",
      failed: "Não foi possível restaurar essa versão.",
    },
    complianceLoadingStep: "CONSTRUINDO ESTRUTURA DE CONFORMIDADE...",
    kbrSummaryLabel: "OBJETIVOS",
    prgLabel: "PRG",
    prgModalTitle: "CRESCIMENTO DE RECEITA POSSÍVEL",
    prgModalDef: "O Crescimento de Receita Possível (PRG) representa o potencial se os KBRs forem aplicados corretamente. É um indicador direcional baseado no contexto do negócio — não uma garantia.",
    complianceCorp: "GOVERNANÇA CORPORATIVA",
    complianceCorpAbbrev: "CORP",
    complianceReg: "REGULATÓRIO",
    complianceRegAbbrev: "REG.",
    complianceEvr: "VALOR EM RISCO",
    complianceEvrAbbrev: "EVR",
    complianceTabSub: "CORP · REG. · EVR",
    downloadLabel: "Baixar",
    downloadLoading: "Gerando PDF…",
    downloadError: "Não foi possível gerar o PDF. Tente novamente.",
    share: {
      label: "Compartilhar",
      title: "COMPARTILHAR CHASSIS",
      intro: "Qualquer pessoa com este link pode ler este Chassis como JSON (apenas ADDIS e BLIPS). A saída original da IA é compartilhada — edições de Tune e Learning NÃO são incluídas.",
      empty: "Nenhum link ativo.",
      create: "CRIAR LINK",
      regenerate: "REGENERAR",
      revoke: "REVOGAR",
      copy: "COPIAR",
      copied: "COPIADO",
      expiry: "EXPIRA",
      newExpiry: "NOVA EXPIRAÇÃO",
      expiryNever: "Nunca",
      expiryInDays: "Em {d} dias",
      expired: "EXPIRADO — regenere para compartilhar novamente",
      close: "FECHAR",
    },
    eliminate: { label: "Eliminar" },
  },
};

export const TIER_CONFIG = [
  { id: "compact",   key: "compact",   tokens: 64000, addisCount: "3–7",  blipsCount: "3–6",  kbrCount: "3–4", descLength: "1 sentence max per field", extras: "" },
  { id: "midsize",   key: "midsize",   tokens: 64000, addisCount: "5–10", blipsCount: "5–8",  kbrCount: "4–5", descLength: "1–2 sentences per field", extras: "Include 2–3 real-world factors per relevant BLIPS section." },
  { id: "executive", key: "executive", tokens: 64000, addisCount: "7–12", blipsCount: "7–10", kbrCount: "5–6", descLength: "2 sentences per field", extras: "Include 3–4 real-world factors per relevant BLIPS section. Add industry-specific benchmarks to KBR targets." },
  { id: "luxury",    key: "luxury",    tokens: 64000, addisCount: "8–15", blipsCount: "8–12", kbrCount: "6–7", descLength: "2–3 sentences per field with specific business context", extras: `Include 4–5 real-world factors per relevant BLIPS section with detailed impact descriptions.\nAlso add these extra top-level JSON fields:\n"benefits": { "BizOps": "paragraph", "Logistics": "paragraph", "Inventory": "paragraph", "Production": "paragraph", "Sales": "paragraph" },\n"risks": [{ "title": "Risk title", "area": "ADDIS or BLIPS area", "severity": "High/Medium/Low", "description": "What this risk is and how Chassis detects it" }],\n"quickWins": [{ "title": "Quick win title", "description": "Specific immediate observability improvement", "impact": "Expected business impact" }]\nGenerate 5 risks and 5 quick wins.` },
];

export function getTiers(lang) {
  return TIER_CONFIG.map((cfg, i) => ({ ...cfg, ...T[lang].tiers[i] }));
}
